// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Utilitiy classes */

.landing-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.landing-content {
  flex: 1 0 auto;
  overflow-x: hidden; /* Prevent horizontal scrolling */
}

/* Prevent content shift by setting explicit heights */
img {
  max-width: 100%;
  height: auto;
  aspect-ratio: attr(width) / attr(height);
}

/* Add this to fix Ant Design layout issues */
.ant-layout, .ant-layout-content {
  transition: none !important; /* Disable transitions that might trigger resize */
}

.spin {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.05);
}

.d-flex {
  display: flex;
}

.flex-grid .flex-grid-child {
  padding: 0 12px;
}

.align-center-v {
  display: flex;
  align-items: center;
}

.justify-content-between {
  justify-content: space-between;
}

.justify-content-center {
  justify-content: center;
}

.align-items-center {
  align-items: center;
}

.line-height-0 {
  line-height: 0;
}

.text-right {
  text-align: right;
}

.text-left {
  text-align: left;
}

.text-center {
  text-align: center;
}

.medium-text {
  font-weight: 500;
}

.status {
  display: inline !important;
  font-size: 13px;
  font-weight: 500;
  background-color: #868eae10;
  padding: 4.5px 11.85px;
  border-radius: 15px;
}

.status.Success {
  background-color: #01b81a10;
  color: #01b81a;
}

.status.warning {
  background-color: #fa8b0c10;
  color: #fa8b0c;
}

.status.error {
  background-color: #FF0F0F10;
  color: #FF0F0F;
}

.modal-video-close-btn {
  cursor: pointer;
}

ul {
  list-style: outside none none;
  margin: 0;
  padding: 0;
}

/* spacing classes */

.m-0 {
  margin: 0 !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-20 {
  margin-bottom: 20px !important;
}

.mb-25 {
  margin-bottom: 25px !important;
}

.mb-30 {
  margin-bottom: 30px;
}

.pb-30 {
  padding-bottom: 30px;
}

.pl-0 {
  padding-left: 0 !important;
}

.mt-20 {
  margin-top: 20px !important;
}

.mt-25 {
  margin-top: 25px;
}

.mt-30 {
  margin-top: 30px;
}

.pr-0 {
  padding-right: 0 !important;
}

/* default card style */

.ant-card {
  box-shadow: 0 5px 20px rgba(173,181,217,.05);
}

.ant-card-body {
  padding: 25px !important;
}

.ant-card-head {
  padding-left: 25px !important;
  padding-right: 25px !important;
}

.ant-card-head-title span {
  display: inline-block;
  margin-left: 15px;
  font-size: 11px;
  font-weight: 500;
  color: #868eae;
}

.ant-card-head .ant-card-extra {
  display: flex;
  align-items: center;
}

.ant-card-head .ant-card-extra:empty {
  display: none;
}

.ant-card-head .ant-card-extra a {
  color: #868eae;
}

.ant-card-extra .ant-dropdown-trigger {
  line-height: 0;
  order: 1;
  margin-left: 20px;
}

.ninjadash-unresizable {
  resize: none;
}

/* ninjaDash Delete Modal */

.ninjaDash-delete-modal .ant-modal-header {
  text-align: center;
  padding: 22px 24px;
}

.ninjaDash-delete-modal .ant-modal-header .ant-modal-title {
  font-size: 20px;
  color: #ff0f0f;
}

.ninjaDash-delete-modal .ant-modal-body {
  padding: 20px 24px;
}

.ninjaDash-delete-modal .ninjadash-delete-confirm {
  text-align: center;
}

.ninjaDash-delete-modal .ninjadash-delete-confirm__action a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  min-height: 32px;
  border-radius: 3px;
  color: #fff;
  background-color: #01b81a;
}

/* NinjaDash Export Modal */
.ninjadash_export-wrap .ninjadash-button-grp {
  margin: -5px;
}

.ninjadash_export-wrap .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
  height: 50px !important;
}

.ninjadash_export-wrap .ant-select-single:not(.ant-select-customize-input) .ant-select-selection-item {
  line-height: 50px !important;
}

.ninjadash_export-wrap .ninjadash-button-grp button {
  min-height: 44px;
}

.ninjadash_export-wrap .ninjadash-button-grp .ant-btn {
  margin: 5px;
}

/* ant radio group */

.ant-radio-button-wrapper-checked {
  color: #fff;
}

/* chart growth upward */

.growth-downward p,
.growth-upward p {
  font-size: 14px;
  color: #868eae;
  margin: 0;
}

.growth-downward h1 sub svg,
.growth-upward h1 sub svg {
  position: relative;
  top: 2px;
  font-size: 14px;
  font-weight: 600;
  left: 5px;
  bottom: 0;
}

/*
.growth-downward h1, .growth-upward h1 {
  font-size: 22px;
  margin: 6px 0 0;
} */

.growth-downward h1 sub {
  color: #FF0F0F;
}

.growth-upward h1 sub {
  color: #01b81a;
}

/* Chart */

.chart-label {
  display: flex;
}

.chart-label .chart-label__single {
  align-items: center;
}

.chart-label .chart-label__single:not(:last-child) {
  margin-right: 40px;
}

.chart-label .chart-label__single p {
  margin: 0;
  color: #868eae;
}

/* revenue doughnut */

.revenue-doughnut {
  display: flex;
  justify-content: center;
}

.revenue-doughnut>div {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.revenue-doughnut .rd-labels {
  width: 100%;
  margin-top: 30px;
}

.revenue-chat-percentage span {
  display: block;
}

.revenue-chat-percentage span:not(:last-child) {
  margin-bottom: 15px;
}

/* progressbars */

.ant-progress {
  display: inline-flex !important;
  align-items: center;
}

.ant-progress>div {
  display: flex;
  flex-direction: column;
}

.ant-progress .ant-progress-outer {
  margin-right: 0 !important;
  padding-right: 0 !important;
}

.revenue-chat-percentage span {
  display: block;
  font-size: 13px;
  color: #868eae;
}

.revenue-chat-percentage span:not(:last-child) {
  margin-bottom: 20px;
}

.ant-progress-status-warning .ant-progress-bg {
  background: #fa8b0c;
}

/* progress bars */

.progress-primary .ant-progress-bg {
  background: #8231D3;
}

.progress-secondary .ant-progress-bg {
  background: #ff69a5;
}

.progress-success .ant-progress-bg {
  background: #01b81a;
}

.progress-info .ant-progress-bg {
  background: #00aaff;
}

.progress-warning .ant-progress-bg {
  background: #fa8b0c;
}

.progress-danger .ant-progress-bg {
  background: #FF0F0F;
}

/* color classes */

.color-primary {
  color: #8231D3;
}

.color-secondary {
  color: #5840ff;
}

.color-info {
  color: #00AAFF;
}

.color-warning {
  color: #fa8b0c;
}

.color-success {
  color: #01b81a;
}

.color-danger {
  color: #FF0F0F;
}

.color-dark {
  color: #0A0A0A;
}

.color-error {
  color: #f5222d;
}

.color-gray {
  color: #404040;
}

/* Button Styles */

.button-example .ant-btn {
  margin: 4px;
}

.button-example .ant-btn-group .ant-btn {
  margin: 0;
}

.ant-btn.ant-btn-white {
  color: #404040;
  border-color: #e3e6ef;
}

.ant-btn.ant-btn-white svg {
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.ant-btn.ant-btn-white:hover {
  color: #8231D3;
  background-color: #fff;
  border-color: #8231D3;
}

.ant-btn.ant-btn-white:hover svg {
  color: #8231D3;
}

.ant-btn-white:focus {
  background-color: transparent !important;
}

.ant-btn.ant-btn-dashed {
  border-width: 1px !important;
  color: #090e30;
}

.ant-btn.ant-btn-dashed:hover {
  color: #8231D3;
  border: 1px dashed #8231D3;
}

.ant-btn-primary[disabled] {
  color: #fff;
  background: #8231D360;
}

.ant-btn-light[disabled] {
  background: #fff;
}

.ant-btn-round.ant-btn-sm {
  height: 38px;
}

.ant-btn-white[disabled] {
  background-color: transparent;
  opacity: 0.6;
}

.ant-btn-white[disabled]:hover {
  color: #404040 !important;
}

.ant-btn-primary[disabled]:hover {
  color: #fff !important;
  background: #8231D360 !important;
}

.btn-icon {
  padding: 0 13px;
}

.btn-inc,
.btn-dec {
  height: 38px;
  width: 38px;
  font-size: 20px;
  padding: 0 12px !important;
  border-radius: 10px !important;
  border: 0 none;
}

.btn-inc:hover,
.btn-dec:hover {
  background: #8231D310 !important;
  border: 0 none !important;
}

.btn-inc:hover i,
.btn-inc:hover svg,
.btn-dec:hover i,
.btn-dec:hover svg {
  color: #8231D3;
}

/* input styles */

.ant-form-item-label>label {
  font-weight: 500;
}

.ant-picker-input>input::placeholder {
  color: #adb4d2 !important;
}

.ant-input-affix-wrapper,
.ant-input {
  border-radius: 6px;
}

.ant-input-affix-wrapper .ant-input-prefix {
  margin-right: 8px;
}

.ant-input-affix-wrapper-lg .ant-input-lg {
  font-size: 15px;
}

/* Calendar Styles */

.ant-picker-calendar-header .ant-select-selector {
  height: 32px !important;
}

.ant-picker-calendar-header .ant-select-selection-search-input {
  height: 30px !important;
}

.ant-select-single .ant-select-selector .ant-select-selection-item {
  line-height: 30px !important;
}

/* pagination */

.ant-pagination .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
  height: 32px !important;
}

.ant-pagination-item-active {
  background-color: #8231D3 !important;
}

.ant-pagination-item-active a {
  color: #fff !important;
}

.ant-pagination .ant-pagination-options .ant-select-selection-item {
  font-size: 13px;
  line-height: 30px !important;
}

.ant-pagination .ant-pagination-options .ant-pagination-options-quick-jumper {
  height: 30px;
  line-height: 30px;
}

.ant-pagination .ant-pagination-options .ant-pagination-options-quick-jumper input {
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.ant-pagination .ant-pagination-prev,
.ant-pagination .ant-pagination-next,
.ant-pagination .ant-pagination-jump-prev,
.ant-pagination .ant-pagination-jump-next,
.ant-pagination .ant-pagination-item,
.ant-pagination .ant-pagination-options .ant-select-selector {
  border: 1px solid #f1f2f6 !important;
  background-color: #fff;
}

.ant-pagination .ant-pagination-jump-prev .ant-pagination-item-ellipsis,
.ant-pagination .ant-pagination-jump-next .ant-pagination-item-ellipsis {
  color: #404040 !important;
  line-height: 2.6;
}

.ant-pagination .ant-pagination-jump-prev .ant-pagination-item-link,
.ant-pagination .ant-pagination-jump-next .ant-pagination-item-link {
  display: block;
}

.ant-pagination-prev,
.ant-pagination-next {
  line-height: 28px !important;
}

.ant-pagination-prev .ant-pagination-item-link,
.ant-pagination-next .ant-pagination-item-link {
  border: 0 none !important;
}

.ant-pagination .ant-pagination-item a {
  color: #404040;
}

.ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-ellipsis,
.ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-ellipsis {
  font-family: "Jost", sans-serif !important;
}

.ant-pagination .ant-select-single .ant-select-selector .ant-select-selection-item {
  line-height: 30px !important;
  color: #404040;
}

.ant-pagination .ant-select-single:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-search-input {
  height: 100% !important;
}

.ant-pagination-item,
.ant-pagination-options,
.ant-pagination-prev,
.ant-pagination-jump-prev,
.ant-pagination-jump-next,
.ant-pagination-next {
  margin: 4px !important;
}

.ant-table-pagination {
  margin-top: 30px !important;
}

.ant-table-thead>tr>th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
  display: none;
}

.ant-table table tr th.ant-table-selection-column,
.ant-table table tr td.ant-table-selection-column {
  padding: 0 16px;
}

/* Wizard Modal */
.submission-successModal {
  text-align: center;
}

.submission-successModal .icon-success {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  border: 1px solid #01b81a;
}

.submission-successModal p {
  margin-bottom: 0;
}

.submission-successModal .icon-success svg {
  color: #01b81a;
}

.submission-successModal .submission-action {
  margin: 30px -5px -5px -5px;
}

.submission-successModal .submission-action button {
  margin: 5px;
  height: 38px;
}

/* Select */

.ant-select:not(.ant-select-customize-input) .ant-select-selector {
  border-color: #e3e6ef;
  border-radius: 6px !important;
}

/* Tree Select */

.ant-tree-select.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
  height: 42px !important;
  line-height: 40px;
}

.ant-tree-select.ant-select-single:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-search-input {
  height: 100% !important;
}

.ant-tree-select.ant-select-single .ant-select-selector .ant-select-selection-placeholder {
  line-height: 40px !important;
}

/* radio style */

.ant-radio-checked .ant-radio-inner {
  border-width: 4px !important;
}

.ant-radio-inner::after {
  content: none !important;
}

/* Statistics */

.ant-statistic .ant-statistic-title {
  color: #9299b8;
}

.ant-statistic .ant-statistic-content span {
  font-size: 20px;
}

/* Steps */

.steps-action.justify-content-center {
  justify-content: center !important;
}

.ant-steps .ant-steps-item:not(.ant-steps-item-active)>.ant-steps-item-container[role="button"]:hover .ant-steps-icon svg {
  color: #8231D3;
}

/* rate */

.ant-rate-star.ant-rate-star-zero span svg {
  color: #c6d0dc;
}

.ant-rate-star:not(:last-child) {
  margin-right: 2px !important;
}

/* result */

.ant-result-icon {
  margin-bottom: 20px !important;
}

.ant-result-title {
  font-weight: 500;
  margin-bottom: 10px;
}

.ant-result-extra {
  height: 34px;
  padding: 4px 10.72px;
}

.ant-result-content .ant-typography strong {
  font-weight: 500;
}

.ant-result-content .ant-typography:last-child {
  margin-bottom: 0;
}

/* form select */

.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
  height: 38px !important;
}

.ant-select-single .ant-select-selector .ant-select-selection-item,
.ant-select-single .ant-select-selector .ant-select-selection-placeholder {
  line-height: 35px !important;
}

.ant-select-multiple .ant-select-selector {
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}

.ninjadash-fullwidth-select {
  width: 100%;
}

/* calendar style */

.events {
  list-style: none;
  margin: 0;
  padding: 0;
}

.events .ant-badge-status {
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  text-overflow: ellipsis;
  font-size: 12px;
}

.notes-month {
  text-align: center;
  font-size: 28px;
}

.notes-month section {
  font-size: 28px;
}

/* Breadcrumb demo */

.demo {
  margin: 16px;
}

.demo-nav {
  height: 30px;
  line-height: 30px;
  margin-bottom: 16px;
  background: #f8f8f8;
}

.demo-nav a {
  line-height: 30px;
  padding: 0 8px;
}

.app-list {
  margin-top: 16px;
}

/* Modal */

.ant-modal .ant-modal-content {
  border-radius: 10px;
}

.ant-modal .ant-modal-header {
  border-radius: 10px 10px 0 0;
}

.ant-modal-body p:last-child {
  margin-bottom: 0;
}

.project-modal {
  padding: 5px !important;
}

.project-modal .projects-members {
  margin-top: -12px;
}

.project-modal .projects-members img {
  margin: 6px;
}

.project-modal .ant-form-item-control-input {
  margin-top: 10px;
  min-height: auto;
}

.project-modal .ant-select-selector {
  border-color: #e3e6ef;
}

.project-modal .ant-picker {
  width: 100%;
}

.project-modal-footer {
  padding: 10px !important;
  text-align: left !important;
}

.ninjadash-addTask-modal {
  max-width: 390px;
}

.ninjadash-addTask-modal .ant-modal-header {
  border-bottom: 0 none;
  padding-bottom: 0 !important;
}

.ninjadash-addTask-modal .ant-modal-header .ant-modal-title {
  font-size: 16px;
  font-weight: 500;
  color: #0A0A0A;
}

.ninjadash-addTask-modal .ninjadash-addTask-modal-inner .ant-form-item {
  margin-bottom: 15px;
}

.ninjadash-addTask-modal .ant-modal-header .ant-modal-close-x svg {
  color: #9299b8;
}

.ninjadash-addTask-modal .ant-form-item-control-input {
  min-height: 36px;
}

.ninjadash-addTask-modal input::placeholder,
.ninjadash-addTask-modal textarea::placeholder {
  color: #9299b8;
}

.ninjadash-addTask-modal input,
.ninjadash-addTask-modal textarea {
  padding: 6px 20px;
  border-radius: 5px;
}

.ninjadash-addTask-modal textarea {
  resize: none;
  min-height: 125px;
}

.ninjadash-addTask-modal .ninjadash-modal-actions {
  display: flex;
  justify-content: flex-end;
  margin: -6px;
}

.ninjadash-addTask-modal .ninjadash-modal-actions button {
  font-size: 14px;
  margin: 6px;
  height: 38px;
  border-radius: 5px;
}

/* slider */

.ant-slider-handle {
  margin-top: -6px !important;
}

.ant-slider .ant-slider-rail,
.ant-slider-track,
.ant-slider .ant-slider-step {
  height: 3px;
}

/* tags */

.ant-tag {
  font-weight: 600;
  padding: 0 9.5px;
}

/* tabs */

.ant-tabs-tab span {
  display: flex;
  align-items: center;
}

/* popover */

.ant-popover {
  position: fixed !important;
  z-index: 99998 !important;
}

.ant-popover .ant-btn-sm {
  font-size: 13px;
}

.ant-popover .ant-popover-inner {
  padding: 15px;
  box-shadow: 0 15px 25px rgba(146, 153, 184, .20);
  border-radius: 6px;
}

.ant-popover-inner .ant-popover-title {
  padding: 5px 10px 10px;
}

.ant-popover-inner .ant-popover-inner-content a {
  color: #404040;
}

/* Drawer */

.ant-drawer {
  z-index: 99999;
}

/* Select Dropdwon */

.ant-select-dropdown {
  padding: 18px 0 !important;
  box-shadow: 0 5px 20px #9299b820 !important;
  border-radius: 0 0 6px 6px !important;
}

.ant-select-item {
  min-height: 20px !important;
  padding: 4px 12px !important;
}

.ant-select-item-group {
  color: #9299b8;
}

.ant-select-item.ant-select-item-option-grouped {
  padding-left: 25px !important;
}

.ant-select-dropdown .ant-select-item.ant-select-item-option-active {
  background: #8231D305;
}

.ant-select-dropdown .ant-select-item.ant-select-item-option-selected .ant-select-item-option-content {
  padding-left: 10px;
}

.ant-select-dropdown .ant-select-item.ant-select-item-option-selected {
  color: #8231D3;
  background: #8231D306;
}

.ant-select-dropdown .ant-select-item.ant-select-item-option-selected .ant-select-item-option-content {
  color: #8231D3;
  font-weight: 500;
}

.ant-select-dropdown .ant-select-item .ant-select-item-option-content {
  transition: 0.3s;
  color: #404040;
}

/* mail props dropdown */

.mail-props {
  padding: 10px 25px;
  border: 0 none;
  background: #fff;
  margin-bottom: 0;
  /* box-shadow: 0 5px 40px rgba(146, 153, 184, 0.25); */
}

.mail-props li {
  display: flex;
  margin-bottom: 12px;
}

.mail-props li span:first-child {
  margin-right: 50px;
  min-width: 40px;
}

.mail-props li span:last-child {
  color: #404040;
}

.mail-props li:last-child {
  margin-bottom: 0;
}

.mail-props li span {
  color: #9299b8;
}

/* Basic Dropdwon */

.ant-dropdown {
  box-shadow: 0 5px 30px #9299b820 !important;
}

.ant-dropdown.wide-dropdwon {
  min-width: 140px !important;
}

.ant-dropdown.wide-dropdwon.kanbanCard-more {
  min-width: 220px !important;
  box-shadow: 0 17px 20px #9299b820;
}

.ant-dropdown.wide-dropdwon.kanbanCard-more a {
  padding: 10px 24px;
}

.ant-dropdown-menu {
  min-width: 200px;
  border-radius: 0 0 5px 5px;
  box-shadow: 0 0;
}

.ant-dropdown-menu li {
  color: #404040;
  padding: 5px 25px;
}

.ant-dropdown-menu li:hover {
  background-color: #8231D305;
}

.ninjadash-top-dropdown .ninjadash-top-dropdown__title {
  background: #f4f5f7;
  width: 100%;
  margin-bottom: 12px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  min-height: 50px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.ninjadash-top-dropdown {
  width: 340px;
}

.ninjadash-top-dropdown .ninjadash-top-dropdown__nav {
  height: 260px;
}

.ninjadash-top-dropdown .ninjadash-top-dropdown__nav.notification-list {
  padding: 0 10px;
}

.ninjadash-top-dropdown .ninjadash-top-dropdown__nav li {
  width: 100%;
}

.ninjadash-top-dropdown .ninjadash-top-dropdown__nav li a {
  padding: 13px 10px;
  position: relative;
  width: 100%;
}

.ninjadash-top-dropdown .ninjadash-top-dropdown__nav li:last-child {
  margin: 0;
}

.ninjadash-top-dropdown a.btn-seeAll {
  position: relative;
  width: calc(100% + 30px);
  left: -15px;
  right: -15px;
  height: calc(100% + 15px);
  bottom: -15px;
  text-align: center;
  font-size: 13px;
  font-weight: 500;
  color: #8231D3;
  padding: 15px 0;
  border-radius: 0 0 6px 6px;
  justify-content: center;
  background: #fff;
  transition: 0.3s;
}

.ninjadash-top-dropdown a.btn-seeAll:before {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  box-shadow: 0 -15px 20px #9299b808;
  z-index: 1;
  content: "";
}

.ninjadash-top-dropdown .ninjadash-top-dropdown__nav li a.btn-seeAll:hover:after {
  box-shadow: 0 0;
}

.ninjadash-top-dropdown .ninjadash-top-dropdown__nav li a:hover {
  background: #fff;
}

.ninjadash-top-dropdown .ninjadash-top-dropdown__nav li a:hover:after {
  opacity: 1;
  visibility: visible;
}

.ninjadash-top-dropdown .ninjadash-top-dropdown__nav li a:hover figcaption h1 {
  color: #8231D3;
}

.ninjadash-top-dropdown .ninjadash-top-dropdown__nav li a:after {
  position: absolute;
  left: -15px;
  right: -15px;
  top: 0;
  width: calc(100% + 30px);
  height: 100%;
  box-shadow: 0 15px 50px #9299b820;
  z-index: 1;
  content: "";
  opacity: 0;
  visibility: hidden;
}

.ninjadash-top-dropdown .ninjadash-top-dropdown__content {
  display: flex;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 0;
}

.ninjadash-top-dropdown .ninjadash-top-dropdown__content .notification-icon {
  width: 39.2px;
  height: 32px;
  margin-right: 15px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ninjadash-top-dropdown .ninjadash-top-dropdown__content .notification-icon.bg-primary {
  background: #8231D315;
  color: #8231D3;
}

.ninjadash-top-dropdown .ninjadash-top-dropdown__content .notification-icon.bg-secondary {
  background: #5840FF15;
  color: #5840FF;
}

.ninjadash-top-dropdown .ninjadash-top-dropdown__content .notification-icon svg {
  width: 18px;
  height: 18px;
}

.ninjadash-top-dropdown .ninjadash-top-dropdown__content .notification-content {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ninjadash-top-dropdown .notification-text h1 {
  font-size: 14px;
  font-weight: 400;
  color: #404040;
  margin-bottom: 4px;
}

.ninjadash-top-dropdown .notification-text h1 span {
  color: #8231D3;
  font-weight: 500;
  padding-left: 0;
}

.ninjadash-top-dropdown .notification-text p {
  font-size: 12px;
  color: #adb4d2;
  margin-bottom: 0;
}

.ninjadash-top-dropdown .ninjadash-top-dropdown__content img {
  max-width: 40px;
}

.ninjadash-top-dropdown .ninjadash-top-dropdown__content figcaption {
  margin: -4px 15px 0;
}

.ninjadash-top-dropdown .ninjadash-top-dropdown__content figcaption .ant-badge-count {
  font-size: 8px;
  min-width: 16px;
  width: 16px;
  height: 16px;
  line-height: 16px;
  border-radius: 8px;
}

.ninjadash-top-dropdown .ninjadash-top-dropdown__content figcaption p.ant-scroll-number-only-unit.current {
  height: 15px;
}

.ninjadash-top-dropdown .ninjadash-top-dropdown__content figcaption h1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 2px;
}

.ninjadash-top-dropdown .ninjadash-top-dropdown__content figcaption h1 span {
  font-size: 12px;
  font-weight: 400;
}

.ninjadash-top-dropdown .ninjadash-top-dropdown__content figcaption p {
  display: flex;
  align-items: center;
  margin-bottom: 0;
}

.add-file-dropdown a {
  font-size: 14px;
  font-weight: 400;
}

.add-file-dropdown a svg {
  width: 14px;
}

.folder-dropdown {
  min-width: 200px !important;
}

/* Tooltip Styles */

.ant-tooltip .ant-tooltip-inner {
  min-height: 40px;
  padding: 6px 20px;
  font-size: 14px;
  color: #404040;
  background-color: #fff;
  border-radius: 3px;
  display: flex;
  align-items: center;
  border: 1px solid #f1f2f6;
  box-shadow: 0 8px 15px #9299b815;
}

.ant-tooltip .ant-tooltip-arrow:after {
  position: absolute;
  left: 50%;
  top: 30px;
  transform: translateX(-50%);
  width: 13px;
  height: 13px;
  background: #fff;
  content: "";
}

.ant-tooltip .ant-tooltip-arrow .ant-tooltip-arrow-content {
  width: 14px;
  height: 14px;
  top: 3px;
  background: #fff;
  z-index: 98;
  --antd-arrow-background-color: #fff;
}

.ant-tooltip .ant-tooltip-arrow .ant-tooltip-arrow-content:before {
  position: static;
}

.ant-tooltip-placement-bottom .ant-tooltip-arrow .ant-tooltip-arrow-content {
  border: 1px solid #e3e6ef;
  box-shadow: 0 0;
}

.ant-tooltip-placement-bottom .ant-tooltip-arrow {
  top: -4.071068px;
}

.ant-slider-tooltip.ant-tooltip-placement-top .ant-tooltip-arrow {
  transform: translateY(80%) translateX(-50%);
}

/* Badge Styles */

.ant-badge.badge-success .ant-badge-count {
  background: #01b81a;
}

.badge {
  font-size: 11px;
  font-weight: 500;
  padding: 0 6.5px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
}

.badge .ant-badge-count {
  box-shadow: 0 0;
}

.badge.badge-primary {
  background: #8231D315;
  color: #8231D3;
}

/* Cascade Styles */

.custom-cascade-render .ant-cascader-picker {
  width: 100%;
}

.ant-cascader-picker input::placeholder {
  color: #adb4d2;
}

/* Comment Styles */

.ant-comment-actions li {
  margin-bottom: 0 !important;
}

/* Radio Vertical Button */

.ant-radio-vertical .ant-radio-wrapper {
  display: block;
}

.ant-radio-vertical .ant-radio-wrapper:not(:last-child) {
  margin-bottom: 14px;
}

/* Select Tree */

.ant-select-tree-list .ant-select-tree-node-content-wrapper:hover {
  background-color: #bae7ff !important;
}

.ant-select-tree-list .ant-select-arrow svg {
  font-size: 10px;
}

.ant-tree-select.ant-select-multiple .ant-select-selection-item {
  border: 0 none;
  border-radius: 3px;
  background: #f4f5f7;
  color: #404040;
  font-weight: 500;
}

/* Ant Switch */

.ant-switch:after {
  width: 14px !important;
  height: 14px !important;
}

.ant-switch-small:after {
  width: 10px !important;
  height: 10px !important;
}

/* Time Picker */

.ant-picker {
  min-width: 250px;
}

/* Input Affix */

.ant-input-affix-wrapper>input.ant-input {
  padding-left: 5px;
}

.ant-input-affix-wrapper .ant-input-prefix svg {
  color: #e3e6ef;
}

.ant-input-affix-wrapper {
  padding: 8px 20px;
}

/* Space Item */

.ant-space-item .ant-btn span {
  font-size: 14px;
}

/* Pop confirm */

.pop-confirm .ant-btn {
  max-width: 90px;
  padding: 0px 35.5px;
  height: 44px;
}

.pop-confirm-top {
  margin-bottom: 10px;
}

.pop-confirm-bottom {
  margin-top: 10px;
}

.pop-confirm-top .ant-btn:not(:last-child),
.pop-confirm-bottom .ant-btn:not(:last-child) {
  margin-right: 10px;
}

.pop-confirm-left .ant-btn:not(:last-child),
.pop-confirm-right .ant-btn:not(:last-child) {
  margin-bottom: 10px;
}

/* Ant Upload */

.ant-upload .ant-btn {
  font-size: 14px;
  border-radius: 5px;
}

.ant-upload.ant-upload-select-picture-card {
  border-color: #e3e6ef !important;
  border-radius: 5px !important;
  background-color: #f8f9fb !important;
}

.ant-upload.ant-upload-select-picture-card .anticon {
  margin-bottom: 8px;
}

.ant-upload .anticon svg {
  color: #9299b8;
}

.ant-upload-list {
  margin-top: 10px !important;
}

.ninjadash-upload-basic .ant-upload.ant-upload-select {
  width: 100%;
  border: 1px solid #e3e6ef;
  border-radius: 4px;
}

.ninjadash-upload-basic .ant-upload.ant-upload-select .ant-upload {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ninjadash-upload-basic .ninjadash-upload-text {
  font-size: 14px;
  color: #9299b8;
  padding-left: 15px;
}

html[dir="rtl"] .ninjadash-upload-basic .ninjadash-upload-text {
  padding-left: 0px;
  padding-right: 15px;
}

.ninjadash-upload-basic .ninjadash-upload-browse {
  font-size: 14px;
  color: #9299b8;
  display: inline-block;
  padding: 14px 23px;
  border-left: 1px solid #e3e6ef;
}

html[dir="rtl"] .ninjadash-upload-basic .ninjadash-upload-browse {
  border-left: 0 none;
  border-right: 1px solid #e3e6ef;
}

.ant-modal-wrap-rtl .ninjadash-event-details-modal .ant-modal-close {
  left: 10px;
}

.ant-card.ninjadash-upload-form .ant-card-body {
  padding-bottom: 15px !important;
}

/* Ant Picker */

.ant-picker {
  border-color: #e3e6ef;
}

/* Ant Dropdown */

.ant-dropdown {
  box-shadow: 0 5px 20px #9299b820;
  background: #fff;
  border-radius: 6px;
  border: 0 none;
}

.ant-dropdown a {
  display: flex;
  align-items: center;
  padding: 8px 24px;
  font-weight: 400;
  color: #404040;
}

.ant-dropdown a i,
.ant-dropdown a svg,
.ant-dropdown a img {
  margin-right: 8px;
  width: 14px;
  height: 14px;
}

.ant-dropdown div {
  box-shadow: 0 0;
  border-radius: 5px;
}

/* Picker Under Input */

.ant-form-item-control-input .ant-picker {
  padding: 0 12px 0 12px;
  min-height: 38px;
  border-color: #e3e6ef;
}

/* Leaflet COntainer */

.leaflet-container {
  z-index: 0;
}

/* Table Bordered*/
.table-bordered .ant-table-thead>tr>th {
  background: #fff;
  border-top: 1px solid #f1f2f6;
}

.table-bordered .ant-table-tbody>tr>td {
  border-color: #f1f2f6 !important;
}

.table-bordered .ant-table-thead tr th,
.table-bordered .ant-table-tbody tr td {
  padding: 16px 25px;
}

.table-bordered .ant-table-thead tr th:last-child,
.table-bordered .ant-table-tbody tr td:last-child {
  text-align: right;
}

/* Table Responsive */

.table-responsive .ant-table-content {
  display: block;
  width: 100%;
  overflow-x: auto;
}

.table-responsive .ant-table-content .ant-table-cell {
  white-space: nowrap;
}

/* Rich TextEditor  */

.RichTextEditor__root___2QXK- {
  border: 0 none !important;
}

.RichTextEditor__root___2QXK- .EditorToolbar__root___3_Aqz {
  margin: 0;
  border-color: #f1f2f6;
}

.RichTextEditor__root___2QXK- .ButtonWrap__root___1EO_R button {
  padding: 0;
  border: 0 none;
  background: #fff;
  margin-right: 8px;
}

.RichTextEditor__root___2QXK- .Dropdown__root___3ALmx .Dropdown__value___34Py9 {
  border: 0 none;
}

.RichTextEditor__root___2QXK- .Dropdown__root___3ALmx select {
  border-right-width: 0px;
  direction: ltr;
}

.RichTextEditor__editor___1QqIU .DraftEditor-editorContainer {
  border: 0 none;
}

/* ChatBox Dropdwon */

.atbd-chatbox__messageControl {
  min-width: 210px;
}

.atbd-chatbox__messageControl ul {
  margin: 0;
  padding: 10px 0;
}

.atbd-chatbox__messageControl ul li a {
  padding: 4px 24px;
}

.atbd-chatbox__emoji {
  margin: -4.48px 0;
  padding: 0 10px;
}

.atbd-chatbox__emoji ul {
  display: flex;
  align-items: center;
}

.atbd-chatbox__emoji ul li {
  display: inline-block;
}

.atbd-chatbox__emoji ul li a {
  display: block;
  font-size: 20px;
  padding: 4px 7px;
  background: #fff;
}

.atbd-chatbox__emoji ul li a:hover {
  background-color: transparent;
}

.atbd-chatbox__emoji ul li a svg {
  margin: 0;
}

.rdrMonths {
  flex-wrap: wrap;
}

.ant-space {
  flex-wrap: wrap;
}

.ant-menu .ant-menu-submenu .ant-menu-submenu-title {
  display: flex;
  align-items: center;
}

.ant-menu-submenu.ant-menu-submenu-inline .ant-menu-submenu-title,
.ant-menu-item {
  display: inline-flex;
}

.ant-menu-submenu-popup {
  z-index: 105;
}

.ant-menu-submenu-popup .ant-menu-sub {
  padding: 8px 0;
}

.ant-menu-submenu-popup .ant-menu-submenu.ant-menu-submenu-inline .ant-menu-submenu-title,
.ant-menu-submenu-popup .ant-menu-item {
  display: block;
}

.ant-menu-submenu-popup .ant-menu-item {
  margin-bottom: 0 !important;
}

.ant-menu-sub.ant-menu-vertical {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.ant-menu-sub.ant-menu-vertical .ant-menu-item a {
  color: #404040;
}

/* Ninjadash Header More */
.ninjadash-header-more .ninjadash-nav-actions__searchbar {
  display: none;
}

/* page heading */

.ant-page-header.header-boxed {
  padding: 26px 180px 26px 180px !important;
}

.ant-page-header-heading {
  align-items: center;
}

.ant-page-header-heading-title {
  text-transform: capitalize;
}

.ant-page-header-heading-sub-title {
  position: relative;
  top: 2px;
}

/* Swiper Sldier */

.swiper-container {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
  z-index: 1;
}

/* Antd drag & drop */

.row-dragging {
  /* background: #fafafa; */
  /* border: 1px solid #ccc; */
  box-shadow: 0 15px 50px #9299b820;
  display: flex;
}

.row-dragging tr {
  box-shadow: 0 15px 50px #9299b820;
}

.row-dragging td {
  padding: 16px;
  color: #000;
  position: relative;
  z-index: 9999;
  opacity: 0.5;
  vertical-align: middle;
}

.row-dragging td .ant-checkbox-checked .ant-checkbox-inner {
  background-color: #01b81a;
  border-color: #01b81a;
}

.row-dragging td .todos-action,
.row-dragging td .table-actions {
  display: none;
}

.row-dragging td .user-info figcaption {
  display: none;
}

.row-dragging td .feather-move,
.row-dragging td .drag_email,
.row-dragging td .drag_company,
.row-dragging td .drag_designation,
.row-dragging td .drag_join-date,
.row-dragging td .active {
  display: inline-block;
  margin-top: 10px;
}

.row-dragging .drag-visible {
  visibility: visible;
}

/* Ninjadash Event Details Modal */
.ninjadash-event-details-modal .ant-modal-content {
  border-radius: 8px;
}

.ninjadash-event-details-modal .ant-modal-close {
  top: 12px;
  right: 10px;
}

.ninjadash-event-details-modal .ant-modal-close-x svg {
  width: 14px;
  height: 14px;
  color: #ffffff75;
}

.ninjadash-event-details-modal .ant-modal-close-x {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  line-height: 1;
  background-color: transparent;
}

.ninjadash-event-details-modal .ant-modal-close-x:hover {
  background-color: #ffffff15;
}

.ninjadash-event-details-modal .ant-modal-close-x:hover svg {
  color: #ffffff;
}

.ninjadash-event-details-modal.ninjadash-event-details-modal-primary .ant-modal-header {
  background-color: #8231D3;
}

.ninjadash-event-details-modal.ninjadash-event-details-modal-secondary .ant-modal-header {
  background-color: #5840ff;
}

.ninjadash-event-details-modal.ninjadash-event-details-modal-success .ant-modal-header {
  background-color: #01b81a;
}

.ninjadash-event-details-modal.ninjadash-event-details-modal-info .ant-modal-header {
  background-color: #00aaff;
}

.ninjadash-event-details-modal.ninjadash-event-details-modal-warning .ant-modal-header {
  background-color: #fa8b0c;
}

.ninjadash-event-details-modal.ninjadash-event-details-modal-danger .ant-modal-header {
  background-color: #ff0f0f;
}

.ninjadash-event-details-modal.ninjadash-event-details-modal-dark .ant-modal-header {
  background-color: #090e30;
}

.ninjadash-event-details-modal .ant-modal-header {
  padding: 19px 24px;
  border-radius: 8px 8px 0 0;
}

.ninjadash-event-details-modal .ant-modal-header .ant-modal-title {
  color: #fff;
  font-size: 16px;
  font-weight: 500;
}

/* File Export Import Modal */
.ninjadash-export-wrap .ant-modal {
  width: 390px !important;
}

.ninjadash-export-wrap .ant-modal .ant-modal-header {
  border-bottom: 0 none;
  padding: 18px 30px 0 30px;
}

.ninjadash-export-wrap .ant-modal .ant-modal-body {
  padding: 25px 30px 30px 30px;
}

.ninjadash-export-wrap .ant-modal .ninjadash-button-grp {
  text-align: right;
}

.ninjadash-export-wrap .ant-modal .ninjadash-button-grp {
  margin: 20px -8px -8px -8px;
}

.ninjadash-export-wrap .ant-modal .ninjadash-button-grp button {
  font-size: 14px;
  font-weight: 500;
  text-align: right;
  height: 40px;
  padding: 0 16px;
  margin: 8px;
}

.ninjadash-export-wrap .ant-modal .ninjadash-button-grp button.ant-btn-white {
  color: #9299b8 !important;
}

.ninjadash-export-wrap .ant-form-item-control-input {
  min-height: 36px;
}

.ninjadash-export-wrap .ant-form-item-control-input input {
  font-size: 14px;
  font-weight: 400;
  padding: 6px 20px;
  border-radius: 5px;
  color: #9299b8;
}

.ninjadash-export-wrap .ant-select-single {
  width: 100% !important;
}

.ninjadash-export-wrap .ant-form .ant-form-item {
  margin-bottom: 15px;
}

.ninjadash-export-wrap .ant-select-single .ant-select-selector {
  padding: 0 20px;
  border-color: #e3e6ef !important;
}

.ninjadash-create-file .ninjadash-button-grp {
  text-align: right;
}

.ninjadash-create-file .ant-modal {
  width: 390px !important;
}

.ninjadash-create-file .ant-modal .ant-form-item {
  margin-bottom: 20px;
}

.ninjadash-create-file .ant-modal-header {
  border-bottom: 0 none;
  padding-bottom: 6px;
}

.ninjadash-create-file .ninjadash-button-grp button {
  height: 40px;
  border-radius: 5px;
  margin: 5px;
}

.ninjadash-create-file .ant-form-item-control-input {
  border-radius: 5px;
}

.ninjadash-create-file .ant-form-item-control-input input {
  border: 1px solid #e3e6ef;
}

/* Task Modal */
.ninjadash-task-details .ant-modal-content .ant-modal-close {
  top: 10px;
}

.ninjadash-task-details .ant-modal-header {
  border-bottom: 0 none;
  padding: 30px 30px 0;
}

.ninjadash-task-details .ant-modal {
  width: 600px !important;
}

.ninjadash-task-details .ant-modal-header .ant-modal-title h4 {
  font-size: 20px;
  font-weight: 500;
  color: #0A0A0A;
  margin-bottom: 4px;
}

.ninjadash-task-details .ant-modal-header .ant-modal-title .sub-text {
  font-size: 14px;
  font-weight: 400;
  color: #868eae;
}

.ninjadash-task-details .ninjadash-task-details-modal .ninjadash-task-details__label {
  font-size: 16px;
  display: block;
  margin-bottom: 8px;
}

.ninjadash-task-details .ninjadash-task-details-modal .ninjadash-task-details-modal__description textarea {
  padding: 10px 20px;
  min-height: 88px;
  width: 100%;
  border: 0 none;
  border-radius: 4px;
  background-color: #f4f5f7;
  resize: none;
}

.ninjadash-task-details .ninjadash-task-details-modal .ninjadash-task-details-modal__description textarea:focus {
  outline: none;
}

.ninjadash-task-details .ninjadash-task-details-modal .ninjadash-task-details-modal__description textarea::placeholder {
  color: #404040;
  font-size: 15px;
}

.ninjadash-task-details .ant-modal-body {
  padding: 14px 30px 30px 30px;
}

.ninjadash-task-details .ant-modal-body .ninjadash-checklist-block {
  margin-top: 26px;
}

.ninjadash-task-details .ant-modal-body .ninjadash-checklist-block .addChecklist-wrap {
  position: relative;
}

.ninjadash-task-details .ant-modal-body .ninjadash-checklist-block .addChecklist-form {
  position: absolute;
  width: 240px;
  padding: 18px;
  left: 0;
  top: 50px;
  box-shadow: 0 15px 30px #9299bb30;
  background-color: #fff;
  border: 1px solid #e3e6ef;
  border-radius: 6px;
  z-index: 222;
}

html[dir="rtl"] .ninjadash-task-details .ant-modal-body .ninjadash-checklist-block .addChecklist-form {
  left: auto;
  right: 0;
}

.ninjadash-task-details .ant-modal-body .ninjadash-checklist-block .addChecklist-form .add-checklist {
  padding: 10px;
  border-radius: 4px;
  background-color: #fff;
  width: 100%;
  height: 38px;
  border: 1px solid #e3e6ef;
}

.ninjadash-task-details .ant-modal-body .ninjadash-checklist-block .addChecklist-form .addChecklist-form-action {
  margin-top: 15px;
}

.ninjadash-task-details .ant-modal-body .ninjadash-checklist-block .addChecklist-form .addChecklist-form-action a {
  position: relative;
  top: 3px;
  display: inline-flex;
  align-items: center;
  line-height: 1;
}

.ninjadash-task-details .ant-modal-body .ninjadash-checklist-block .addChecklist-form .addChecklist-form-action a svg {
  color: #9299bb;
}

.ninjadash-task-details .ant-modal-body .ninjadash-checklist-block .addChecklist-form .addChecklist-form-action .btn-add {
  margin-right: 15px;
}

html[dir="rtl"] .ninjadash-task-details .ant-modal-body .ninjadash-checklist-block .addChecklist-form .addChecklist-form-action .btn-add {
  margin-left: 15px;
  margin-right: 0;
}

.ninjadash-task-details .ant-modal-body .ninjadash-checklist-block button {
  height: 38px;
  padding: 0px 18.37px;
}

.ninjadash-task-details .ant-modal-body .ninjadash-checklist-row {
  margin-top: 26px;
}

.ninjadash-task-details .ant-modal-body .ninjadash-checklist-row .ninjadash-checklist-item:not(:last-child) {
  margin-bottom: 30px;
}

.ninjadash-task-details .ant-modal-body .ninjadash-checklist-row .ninjadash-checklist-item__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.ninjadash-task-details .ant-modal-body .ninjadash-checklist-row .ninjadash-checklist-item__top button {
  padding: 0px 16.32px;
  color: #525768;
  background-color: #f4f5f7;
}

.ninjadash-task-details .ant-modal-body .ninjadash-checklist-row .ninjadash-checklist-item__title {
  font-size: 16px;
  font-weight: 500;
  color: #090e30;
  margin-bottom: 0;
}

.ninjadash-task-details .ant-modal-body .ninjadash-checklist-row .ninjadash-checklist__progress .ant-progress-inner .ant-progress-bg {
  height: 5px !important;
  background-color: #01b81a;
}

.ninjadash-task-details .ant-modal-body .ninjadash-checklist-row .ninjadash-checklist__progress .ant-progress .ant-progress-text {
  font-size: 12px;
  font-weight: 500;
  order: -1;
  margin: 0 10px 0 0;
}

html[dir="rtl"] .ninjadash-task-details .ant-modal-body .ninjadash-checklist-row .ninjadash-checklist__progress .ant-progress .ant-progress-text {
  margin: 0 0 0 10px;
}

.ninjadash-task-details .ant-modal-body .ninjadash-checklist-tasks {
  margin: 5px 0 5px 0;
}

.ninjadash-task-details .ant-modal-body .ninjadash-checklist-tasks .ant-checkbox-wrapper .ant-checkbox-inner {
  width: 18px;
  height: 18px;
  border-color: #c6d0dc;
}

.ninjadash-task-details .ant-modal-body .ninjadash-checklist-tasks .ant-checkbox-wrapper .ant-checkbox-checked .ant-checkbox-inner {
  background-color: #01b81a;
}

.ninjadash-task-details .ant-modal-body .ninjadash-checklist-tasks .ant-checkbox-wrapper .ant-checkbox-checked:after {
  border-color: #01b81a;
}

.ninjadash-task-details .ant-modal-body .ninjadash-checklist-item .ninjadash-checklist-tasks-wrap button {
  padding: 0px 35px;
  color: #525768;
  background-color: #f4f5f7;
}

.ninjadash-task-details .ant-modal-body {
  max-height: 800px;
  overflow-y: auto;
}

@media (max-width: 767px) {
  .ant-page-header {
    padding: 26px 15px 26px 15px;
  }
}

.page-header-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  margin: -6px -4px;
}

.page-header-actions button {
  font-size: 12px;
  font-weight: 500;
  height: 34px;
  padding: 0 12.32px;
  box-shadow: 0 3px 5px #9299b805;
  margin: 6px 4px;
}

.page-header-actions button.ant-btn-white:focus {
  background-color: #fff !important;
}

.page-header-actions button+button {
  margin-left: 8px;
}

.page-header-actions button.ant-btn-white svg {
  width: 12px;
  height: 12px;
  margin-right: 2px;
  color: #8231D3;
}

/* Layout Css */

.ant-menu-dark .ant-menu-item a {
  font-weight: 400;
  color: rgba(255, 255, 255, 0.65) !important;
}

.ant-menu-dark .ant-menu-item a:hover {
  color: #ffffff;
}

.ant-menu-dark .ant-menu-submenu span {
  color: rgba(255, 255, 255, 0.65) !important;
}

.ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background-color: rgba(255, 255, 255, 0.05);
}

.ant-menu-inline-collapsed-tooltip a {
  color: #000 !important;
}

.ant-menu.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow::before {
  background: transparent;
}

/* Chart Label */

.chart-label {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 6px;
  color: #404040;
}

.chart-label .label-dot {
  margin-right: 8px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
}

.chart-label .label-dot.dot-success {
  background: #01b81a;
}

.chart-label .label-dot.dot-info {
  background: #8231D3;
}

.chart-label .label-dot.dot-warning {
  background: #fa8b0c;
}

/* NOtification CSS */

.ant-notification {
  z-index: 99999 !important;
}

.rdrInputRange {
  padding-left: 10px !important;
}

/* Overlay Dark */
.overlay-dark {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #10122130;
  z-index: -1;
  opacity: 0;
  visibility: hidden;
}

.overlay-dark.show {
  z-index: 998;
  opacity: 1;
  visibility: visible;
}

/* Responsive CSS */

@media only screen and (max-width: 1599px) {
  .ant-page-header.header-boxed {
    padding: 26px 130px 26px 130px !important;
  }
}

@media only screen and (max-width: 1500px) {
  .full-width-table .revenue-table {
    min-height: 100%;
  }

  .pop-confirm .ant-btn {
    padding: 0 20px;
    max-width: 60px;
  }

  .pop-confirm.pop-confirm-right {
    margin-left: 300px !important;
  }

  .pop-confirm.pop-confirm-bottom,
  .pop-confirm.pop-confirm-top {
    margin-left: 80px !important;
  }
}

@media only screen and (max-width: 1399px) {
  .ant-page-header.header-boxed {
    padding: 26px 50px 26px 50px !important;
  }
}

@media only screen and (max-width: 1199px) {
  .ant-page-header {
    padding: 0 15px;
  }
}

@media only screen and (max-width: 991px) {
  .ant-page-header.header-boxed {
    padding: 26px 30px 26px 30px !important;
  }

  .rdrMonths .rdrMonth {
    width: 100%;
    margin-bottom: 30px;
  }

  .rdrDateRangePickerWrapper.PreviewArea {
    max-height: 300px;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .rdrCalendarWrapper.rdrDateRangeWrapper {
    margin-top: 20px;
  }

  .ant-menu-inline-collapsed-tooltip {
    display: none;
  }
}

@media only screen and (max-width: 800px) {
  .ant-page-header-heading-left {
    max-width: 320px;
  }
}

@media only screen and (max-width: 767px) {
  .ant-page-header {
    padding: 26px 15px 26px 15px;
  }

  .ant-page-header-heading {
    flex-flow: column;
    align-items: center;
    justify-content: center !important;
  }

  .ant-page-header-heading-left {
    max-width: 100%;
  }

  .ant-page-header-heading .ant-page-header-heading-title {
    white-space: normal;
    text-align: center;
  }

  .ant-page-header-heading-extra {
    white-space: normal !important;
    margin: 12px 0 4px !important;
  }

  .ant-page-header-heading-extra .page-header-actions {
    white-space: normal !important;
    text-align: center;
  }

  .ant-card-body {
    padding: 20px !important;
  }

  .ant-card-head {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }

  .ant-pagination .ant-pagination-item,
  .ant-pagination .ant-pagination-item.ant-pagination-prev,
  .ant-pagination .ant-pagination-item.ant-pagination-next,
  .ant-pagination .ant-pagination-jump-prev {
    margin-right: 5px;
  }

  .ant-pagination li.ant-pagination-item,
  .ant-pagination li.ant-pagination-prev,
  .ant-pagination li.ant-pagination-next,
  .ant-pagination li.ant-pagination-jump-prev,
  .ant-pagination li.ant-pagination-jump-next {
    font-size: 13px;
    height: 25px;
    min-width: 25px;
    line-height: 22px;
  }

  .ant-pagination li.ant-pagination-prev .anticon,
  .ant-pagination li.ant-pagination-next .anticon {
    vertical-align: 0.15em;
  }

  .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-ellipsis,
  .ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-ellipsis {
    line-height: 2;
    font-family: "Jost", sans-serif;
  }

  .ant-table-pagination {
    float: none !important;
    text-align: center;
  }

  .ant-table-pagination li.ant-pagination-total-text {
    display: block;
    margin-bottom: 8px;
  }

  .ant-table-pagination li {
    margin-right: 8px !important;
  }

  .ant-pagination .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    height: 25px !important;
  }

  .ant-pagination .ant-select-single .ant-select-selector .ant-select-selection-item {
    line-height: 23px !important;
  }

  .rdrDefinedRangesWrapper {
    border-right: 0 none;
  }

  .project-modal .ant-picker {
    margin-bottom: 30px;
  }

  .project-modal {
    padding: 0 !important;
  }
}

@media only screen and (max-width: 575px) {
  .mt-sm-10 {
    margin-top: 10px;
  }

  .ant-page-header-heading-left {
    margin-top: 0;
  }

  .btn-inc,
  .btn-dec {
    height: 30px;
    width: 30px;
  }

  .ant-page-header {
    padding: 26px 20px 16px;
  }

  .ant-layout-header {
    height: auto;
  }

  .ant-card-head {
    line-height: 1;
  }

  .ant-card-head-title {
    white-space: normal !important;
  }

  .pop-confirm .ant-btn {
    max-width: 60px;
    padding: 0 20px;
  }

  .pop-confirm.pop-confirm-right {
    margin-left: 320px !important;
  }

  .pop-confirm.pop-confirm-bottom {
    margin-left: 95px !important;
  }

  /* Card Heading */
  .ant-card-head-wrapper {
    flex-flow: column;
    align-items: center;
  }

  .ant-card-head-wrapper .ant-card-extra {
    padding: 0 0 16px !important;
    float: none;
    margin: 0;
    flex-flow: column;
  }

  .ant-card-head-wrapper .ant-card-extra .ant-dropdown-trigger+.card-nav {
    margin-bottom: 8px;
  }

  .ant-card-head-wrapper .ant-card-extra .ant-dropdown-trigger {
    margin: 0 !important;
  }

  .card-nav ul li.active:before {
    display: none;
  }

  .ant-card-head-title>div {
    display: flex;
    flex-flow: column;
    align-items: center;
  }

  .ant-card-head-title>div span {
    margin: 8px 0 0;
  }

  .ant-picker-range-wrapper {
    min-width: auto !important;
  }

  .ant-picker-panel-container .ant-picker-panels,
  .ant-picker-datetime-panel {
    flex-direction: column;
  }
}

.bmzxig .ant-table tr th:first-child,
.bmzxig .ant-table tr td:first-child {
  padding-right: 15px;
}

/* Emprt */

.ant-empty .ant-empty-footer button {
  padding: 0px 15.58px !important;
}

/* Add Event Modal */
.addEvent-modal .ant-modal-header {
  padding: 20px 25px;
}

.addEvent-modal .ant-modal-header .ant-modal-close-x svg {
  color: #404040;
}

.addEvent-modal .ant-modal-header .ant-modal-title {
  font-size: 15px;
  font-weight: 500;
  color: #0A0A0A;
}

.addEvent-modal .ant-modal-body {
  padding: 23px 25px;
}

/* Event Dropdown */

.event-dropdown {
  min-width: auto !important;
  max-width: 450px;
  padding: 0 !important;
  margin: 6px 0 0 !important;
  box-shadow: 0 10px 40px #9299b820 !important;
}

.event-dropdown div {
  border-radius: 8px;
}

.event-dropdown .ant-card {
  width: 100% !important;
  margin-bottom: 0 !important;
}

.placement-confirm .ant-btn.ant-btn-white:hover {
  border-color: #8231D3;
}

@media only screen and (max-width: 479px) {
  .placement-confirm {
    display: flex;
    flex-wrap: wrap;
    margin: -5px -10px 0 -5px;
  }

  .placement-confirm .pop-confirm {
    flex: 0 0 50%;
  }

  .pop-confirm .ant-btn {
    display: block;
    padding: 0 20px;
    max-width: 80px;
    min-width: 80px;
    margin: 10px;
  }

  .pop-confirm.pop-confirm-right {
    margin-left: 0px !important;
  }

  .pop-confirm.pop-confirm-top {
    margin-left: 0px !important;
  }

  .pop-confirm.pop-confirm-bottom {
    margin-left: 0px !important;
    margin-top: 0px !important;
  }
}

@media only screen and (max-width: 400px) {
  .ant-select {
    width: 100% !important;
  }

  .rdrDefinedRangesWrapper {
    width: 100% !important;
  }

  .rdrDateRangePickerWrapper {
    flex-wrap: wrap;
  }

  .ninjadash-top-dropdown {
    width: 280px;
    min-width: 180px;
  }

  .ninjadash-top-dropdown .ninjadash-top-dropdown__title {
    min-height: 40px;
  }

  .ninjadash-top-dropdown .ninjadash-top-dropdown__nav li:not(:last-child) {
    margin-bottom: 10px;
  }

  .ninjadash-top-dropdown .ninjadash-top-dropdown__nav li a {
    padding: 10px 0px;
  }

  .ninjadash-top-dropdown .ninjadash-top-dropdown__content img {
    margin-right: 15px;
  }

  .ninjadash-top-dropdown .ninjadash-top-dropdown__content figcaption {
    margin-left: 0;
  }

  .ninjadash-top-dropdown .ninjadash-top-dropdown__content figcaption .ninjadash-top-dropdownText {
    min-width: 155px;
  }

  .ant-drawer-content-wrapper {
    width: 260px !important;
  }

  .rdrCalendarWrapper.rdrDateRangeWrapper {
    margin-top: 0;
  }
}

@media only screen and (max-width: 379px) {
  .ant-card-head-wrapper .ant-card-extra .ant-radio-button-wrapper {
    height: 32px !important;
    line-height: 30px !important;
  }

  .ant-notification-notice {
    width: 275px;
  }
}

@media (max-width: 575px) {
  .ant-card-body {
    padding: 15px !important;
  }
}

@media (max-width: 991px) {
  .mail-sideabr {
    box-shadow: 0 0 10px #00000020;
  }

  .ant-card-head-title span {
    margin-left: 10px;
  }
}

/* Invoice Print Style */
@media print {
  .invoice-area .ant-page-header {
    display: none;
  }

  .customizer-trigger {
    display: none;
  }
}

/* .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn{
  color: #fff !important;
} */

/* custom label */

/* card spin loader */

.ant-card-body .sd-spin div,
.ant-card-body .spin div {
  position: relative;
}

.ant-card-body .sd-spin,
.ant-card-body .spin {
  height: 200px;
}

.ant-card-body {
  position: relative;
}

.ant-card-body .sd-spin .ant-spin,
.ant-card-body .spin .ant-spin {
  display: flex;
  align-items: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  min-height: 200px;
}

.starActive svg {
  color: red;
}

/* vectormap zoom in / zoom out */

.jvectormap-zoomin,
.jvectormap-zoomout {
  width: 27px;
  height: 27px;
  background: none;
  color: #404040;
  border: 1px solid #f1f2f6;
  padding: 0;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  left: auto;
  right: 0;
  top: auto;
  background-color: #fff;
}

.jvectormap-zoomin {
  border-radius: 6px 6px 0 0;
  bottom: 36px;
}

.jvectormap-zoomout {
  border-radius: 0 0 6px 6px;
  bottom: 10px;
}

.jvectormap-tip {
  padding: 7px 12px;
  border: 0 none;
  font-size: 12px;
  background: #0A0A0A;
}

.btn-rtl {
  width: 60px;
  height: 60px;
  border: 1px solid #fff;
  background: #4347d9;
  color: #fff;
  position: fixed;
  right: 0;
  top: 50%;
  margin-top: -30px;
  z-index: 99999999;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* masonry-grid start from here */

.my-masonry-grid {
  /* Not needed if autoprefixing */
  /* Not needed if autoprefixing */
  display: flex;
  margin-left: -10px;
  /* gutter size offset */
  width: auto;
}

.my-masonry-grid_column {
  padding-left: 10px;
  /* gutter size */
  background-clip: padding-box;
}

/* Style your items */

.my-masonry-grid_column>div {
  /* change div to reference your elements you put in <Masonry> */
  background: grey;
  margin-bottom: 30px;
}

.common-ul {
  padding: 5px 0;
  padding-left: 10px;
}

.display {
  display: none;
}

li.active>.display {
  display: block;
}

/* rtl section from here */
html[dir="rtl"] .ant-card-head-title span {
  margin-right: 15px;
}

html[dir="rtl"] span[aria-label="arrow-right"] svg,
html[dir="rtl"] span[aria-label="arrow-left"] svg {
  transform: rotateY(180deg);
}

html[dir="rtl"] .ant-menu.ant-menu-vertical {
  text-align: right !important;
}

html[dir="rtl"] .ant-menu.ant-menu-vertical .ant-menu-submenu-placement-rightTop {
  left: -170px !important;
}

html[dir="rtl"] .ant-menu.ant-menu-vertical .ant-menu-vertical-left {
  text-align: right;
}

html[dir="rtl"] .ant-modal-confirm .ant-modal-confirm-btns .ant-btn+.ant-btn {
  margin-left: 0;
  margin-right: 8px;
}

html[dir="rtl"] .ant-menu.ant-menu-vertical .ant-menu-submenu-arrow {
  right: auto;
  left: 16px;
  transform: rotateY(180deg);
}

html[dir="rtl"] .ant-menu-vertical .ant-menu-submenu-title {
  padding-right: 15px !important;
}

html[dir="rtl"] .project-modal-footer {
  text-align: right !important;
}

html[dir="rtl"] .ant-card-extra .ant-dropdown-trigger {
  margin-right: 20px !important;
  margin-left: 0 !important;
}

html[dir="rtl"] .dark-mode .ninjadash-navbar-menu {
  margin-right: 20px;
}

/* Dark Mode Css */
.dark-mode .RichTextEditor__root___2QXK- .ButtonWrap__root___1EO_R button span {
  display: flex;
}

.dark-mode .RichTextEditor__root___2QXK- .ButtonWrap__root___1EO_R button {
  background: #a4a5aa;
}

.dark-mode .ninjadash-top-dropdown a.btn-seeAll,
.dark-mode .ninjadash-top-dropdown .ninjadash-top-dropdown__nav li a:hover,
.dark-mode .ant-picker-panel-container,
.dark-mode .editor-compose .ant-input,
.dark-mode .ant-drawer-content,
.dark-mode .ant-dropdown,
.dark-mode .mail-props,
.dark-mode .ant-popover-inner,
.dark-mode .ninjadash-searchbar .ant-input,
.dark-mode .ant-input-group-addon,
.dark-mode .ant-popover-arrow-content,
.dark-mode .ant-drawer-header,
.dark-mode .ant-popover-arrow-content:before {
  background: #1b1e2b;
}

.dark-mode .ant-btn.ant-btn-white,
.dark-mode .ant-notification-notice,
.dark-mode .ant-pagination-prev .ant-pagination-item-link,
.dark-mode .ant-pagination-next .ant-pagination-item-link,
.dark-mode .ant-pagination .ant-pagination-prev,
.dark-mode .ant-pagination .ant-pagination-next,
.dark-mode .ant-pagination .ant-pagination-jump-prev,
.dark-mode .ant-pagination .ant-pagination-jump-next,
.dark-mode .ant-pagination .ant-pagination-item,
.dark-mode .ant-pagination .ant-pagination-options .ant-select-selector,
.dark-mode .ant-modal .ant-modal-header,
.dark-mode .ant-modal .ant-modal-content,
.dark-mode .ant-modal .ant-modal-content .ant-card,
.dark-mode .ant-input,
.dark-mode .ant-select:not(.ant-select-customize-input) .ant-select-selector,
.dark-mode .ant-form-item-control-input .ant-picker,
.dark-mode .ant-pagination-options-quick-jumper input {
  background-color: #282b37;
}

.dark-mode .ninjadash-task-details .ninjadash-task-details-modal .ninjadash-task-details-modal__description textarea,
.dark-mode .ant-picker-range-arrow::before,
.dark-mode .ninjadash-top-dropdown .ninjadash-top-dropdown__title {
  background-color: #323541;
}

.dark-mode .ant-picker-range-arrow {
  background: linear-gradient(135deg, transparent 40%, #323541 40%);
}

.dark-mode .ant-btn.ant-btn-white,
.dark-mode .ant-btn.ant-btn-dark,
.dark-mode .ant-btn.ant-btn-dashed,
.dark-mode .RichTextEditor__root___2QXK- .ButtonWrap__root___1EO_R button,
.dark-mode .ant-popover-inner .ant-popover-inner-content a,
.dark-mode .pop-confirm .ant-btn,
.dark-mode .ant-pagination-disabled .ant-pagination-item-link,
.dark-mode .ant-pagination-disabled:hover .ant-pagination-item-link,
.dark-mode .ant-pagination .ant-pagination-item a,
.dark-mode .ant-notification-notice-description,
.dark-mode .ant-notification-notice-close-x svg,
.dark-mode .ant-modal-close-x svg,
.dark-mode .ant-drawer-body,
.dark-mode .ant-modal-body,
.dark-mode .ant-modal-confirm-body .ant-modal-confirm-content,
.dark-mode .ant-form-item-control-input .ant-picker,
.dark-mode .ant-select-arrow svg,
.dark-mode .ant-picker-range-separator svg,
.dark-mode .ant-picker-suffix svg,
.dark-mode .ninjadash-searchbar .ant-input,
.dark-mode .ant-picker-cell.ant-picker-cell-in-view,
.dark-mode .ninjadash-task-details .ant-modal-header .ant-modal-title .sub-text,
.dark-mode .ant-popover-message-title {
  color: #a4a5aa;
}

.dark-mode .ant-picker-cell {
  color: #a4a5aa25;
}

.dark-mode .ninjadash-top-dropdown__title,
.ninjadash-task-details .ant-modal-body .ninjadash-checklist-row .ninjadash-checklist-item__title,
.dark-mode .ninjadash-top-dropdown .ninjadash-top-dropdown__content figcaption h1,
.dark-mode .ninjadash-top-dropdown .ninjadash-top-dropdown__nav li a:hover figcaption h1,
.dark-mode .ninjadash-task-details .ant-modal-header .ant-modal-title h4,
.dark-mode .ant-modal-title,
.dark-mode .ant-modal-confirm-body .ant-modal-confirm-title,
.dark-mode .ant-drawer-title,
.dark-mode .ant-form-item-label>label,
.dark-mode .ant-picker-header button,
.dark-mode .ant-notification-notice-message {
  color: #fff;
}

.dark-mode .ant-btn.ant-btn-white:hover {
  color: #8231D3;
}

.dark-mode .ninjadash-task-details .ant-modal-body .ninjadash-checklist-tasks .ant-checkbox-wrapper .ant-checkbox-inner,
.dark-mode .ant-btn.ant-btn-dark,
.dark-mode .ant-btn.ant-btn-white.btn-outlined,
.dark-mode .pop-confirm .ant-btn,
.dark-mode .ant-pagination .ant-pagination-prev,
.dark-mode .ant-pagination .ant-pagination-next,
.dark-mode .ant-pagination .ant-pagination-jump-prev,
.dark-mode .ant-pagination .ant-pagination-jump-next,
.dark-mode .ant-pagination .ant-pagination-item,
.dark-mode .ant-pagination-options-quick-jumper input,
.dark-mode .ant-modal-header,
.dark-mode .ant-modal-footer,
.dark-mode .ant-pagination .ant-pagination-options .ant-select-selector,
.dark-mode .ant-input-group-addon,
.dark-mode .ant-select:not(.ant-select-customize-input) .ant-select-selector,
.dark-mode .ant-form-item-control-input .ant-picker,
.dark-mode .ant-picker-header,
.dark-mode .ant-picker-panel-container .ant-picker-panel,
.dark-mode .ant-drawer-header,
.dark-mode .ant-input {
  border-color: #323541 !important;
}

.dark-mode .ant-pagination .ant-pagination-prev,
.dark-mode .ant-pagination .ant-pagination-next,
.dark-mode .ant-pagination .ant-pagination-jump-prev,
.dark-mode .ant-pagination .ant-pagination-jump-next,
.dark-mode .ant-pagination .ant-pagination-item,
.dark-mode .ant-pagination .ant-pagination-options .ant-select-selector {
  border: 1px solid #282B37 !important;
  background-color: #fff;
}

.dark-mode .ant-btn.ant-raised.ant-btn-white,
.dark-mode .ant-badge-dot,
.dark-mode .ant-badge-count {
  box-shadow: 0 5px 10px #8c90a410;
}

.dark-mode .ant-btn.ant-btn-dashed {
  border-color: #494b55;
}

.dark-mode .ninjadash-navbar-menu {
  margin-left: 20px;
}

/* Top Menu */

.ninjadash-topmenu .ninjadash-blog-details .ninjadash-share-links {
  margin-left: 1000px !important;
}

/* Auth0 style */

.auth0-lock.auth0-lock .auth0-lock-header-logo {
  height: 32px !important;
  margin: 0 0 3px !important;
}

.auth0-lock.auth0-lock .auth0-lock-name {
  font-size: 16px !important;
}`, "",{"version":3,"sources":["webpack://./src/static/css/style.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB,EAAE,iCAAiC;AACvD;;AAEA,sDAAsD;AACtD;EACE,eAAe;EACf,YAAY;EACZ,wCAAwC;AAC1C;;AAEA,6CAA6C;AAC7C;EACE,2BAA2B,EAAE,kDAAkD;AACjF;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,SAAS;EACT,UAAU;AACZ;;AAEA,oBAAoB;;AAEpB;EACE,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,uBAAuB;;AAEvB;EACE,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA,2BAA2B;;AAE3B;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA,oBAAoB;;AAEpB;EACE,WAAW;AACb;;AAEA,wBAAwB;;AAExB;;EAEE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,SAAS;AACX;;AAEA;;;;GAIG;;AAEH;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,UAAU;;AAEV;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA,qBAAqB;;AAErB;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;;AAEjB;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;;AAElB;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;;AAElB;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;;AAElB;EACE,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,0BAA0B;EAC1B,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;;EAEE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA,iBAAiB;;AAEjB;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA,oBAAoB;;AAEpB;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,eAAe;;AAEf;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;;;;;EAME,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;;;;EAME,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,WAAW;;AAEX;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA,gBAAgB;;AAEhB;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,gBAAgB;;AAEhB;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,eAAe;;AAEf;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,UAAU;;AAEV;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA,SAAS;;AAET;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,WAAW;;AAEX;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,gBAAgB;;AAEhB;EACE,uBAAuB;AACzB;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;;AAEA,mBAAmB;;AAEnB;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,oBAAoB;;AAEpB;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,UAAU;;AAEV;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,WAAW;;AAEX;EACE,2BAA2B;AAC7B;;AAEA;;;EAGE,WAAW;AACb;;AAEA,SAAS;;AAET;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,SAAS;;AAET;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,YAAY;;AAEZ;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA,WAAW;;AAEX;EACE,cAAc;AAChB;;AAEA,oBAAoB;;AAEpB;EACE,0BAA0B;EAC1B,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,wBAAwB;;AAExB;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;;AAEnB;EACE,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,UAAU;EACV,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,wBAAwB;EACxB,YAAY;EACZ,iCAAiC;EACjC,UAAU;EACV,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,mBAAmB;;AAEnB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,gBAAgB;EAChB,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,iBAAiB;;AAEjB;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,mBAAmB;;AAEnB;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;;AAEnB;EACE,2BAA2B;AAC7B;;AAEA,0BAA0B;;AAE1B;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;;AAEhB;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA,eAAe;;AAEf;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,gBAAgB;;AAEhB;EACE,gBAAgB;AAClB;;AAEA,gBAAgB;;AAEhB;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,eAAe;;AAEf;EACE,eAAe;AACjB;;AAEA,gBAAgB;;AAEhB;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,eAAe;;AAEf;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,+BAA+B;AACjC;;AAEA,eAAe;;AAEf;EACE,qBAAqB;AACvB;;AAEA,iBAAiB;;AAEjB;EACE,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA,uBAAuB;;AAEvB;EACE,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,sBAAsB;;AAEtB;EACE,UAAU;AACZ;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA,qBAAqB;;AAErB;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qBAAqB;;AAErB;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;;AAErB;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;AACf;;AAEA,iBAAiB;;AAEjB;EACE,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA,kBAAkB;;AAElB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,UAAU;AACZ;;AAEA,qBAAqB;;AAErB;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;;EAME,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,OAAO;EACP,SAAS;EACT,iCAAiC;EACjC,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA,eAAe;;AAEf;EACE,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,gBAAgB;;AAEhB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qBAAqB;;AAErB;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,mBAAmB;AACrB;;AAEA,mBAAmB;;AAEnB;EACE;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;;IAEE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,uCAAuC;EACzC;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,kCAAkC;EACpC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;;EAEA;IACE,8BAA8B;IAC9B,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA;;;;IAIE,iBAAiB;EACnB;;EAEA;;;;;IAKE,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;;IAEE,cAAc;IACd,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA,iBAAiB;EACjB;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,4BAA4B;IAC5B,WAAW;IACX,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,sBAAsB;EACxB;AACF;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,UAAU;;AAEV;EACE,+BAA+B;AACjC;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,mBAAmB;;AAEnB;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,aAAa;IACb,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,eAAe;IACf,eAAe;IACf,eAAe;IACf,YAAY;EACd;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;IAC3B,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,4BAA4B;EAC9B;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,wBAAwB;AACxB;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;;GAEG;;AAEH,iBAAiB;;AAEjB,qBAAqB;;AAErB;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA,iCAAiC;;AAEjC;;EAEE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,UAAU;EACV,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,QAAQ;EACR,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,QAAQ;EACR,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,iCAAiC;;AAEjC;EAEE,gCAAgC;EAEhC,gCAAgC;EAChC,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,qBAAqB;;AAErB;EACE,+DAA+D;EAC/D,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;AACpB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;;EAaE,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;;;;;;EAiBE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,iEAAiE;AACnE;;AAEA;;;;;;;;;;;;;;;;;;;;;;;EAuBE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;;;;;;EAWE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;;;;;;;EAoBE,gCAAgC;AAClC;;AAEA;;;;;;EAME,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,aAAa;;AAEb;EACE,8BAA8B;AAChC;;AAEA,gBAAgB;;AAEhB;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["/* Utilitiy classes */\r\n\r\n.landing-layout {\r\n  min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.landing-content {\r\n  flex: 1 0 auto;\r\n  overflow-x: hidden; /* Prevent horizontal scrolling */\r\n}\r\n\r\n/* Prevent content shift by setting explicit heights */\r\nimg {\r\n  max-width: 100%;\r\n  height: auto;\r\n  aspect-ratio: attr(width) / attr(height);\r\n}\r\n\r\n/* Add this to fix Ant Design layout issues */\r\n.ant-layout, .ant-layout-content {\r\n  transition: none !important; /* Disable transitions that might trigger resize */\r\n}\r\n\r\n.spin {\r\n  height: 100vh;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: rgba(255, 255, 255, 0.05);\r\n}\r\n\r\n.d-flex {\r\n  display: flex;\r\n}\r\n\r\n.flex-grid .flex-grid-child {\r\n  padding: 0 12px;\r\n}\r\n\r\n.align-center-v {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.justify-content-between {\r\n  justify-content: space-between;\r\n}\r\n\r\n.justify-content-center {\r\n  justify-content: center;\r\n}\r\n\r\n.align-items-center {\r\n  align-items: center;\r\n}\r\n\r\n.line-height-0 {\r\n  line-height: 0;\r\n}\r\n\r\n.text-right {\r\n  text-align: right;\r\n}\r\n\r\n.text-left {\r\n  text-align: left;\r\n}\r\n\r\n.text-center {\r\n  text-align: center;\r\n}\r\n\r\n.medium-text {\r\n  font-weight: 500;\r\n}\r\n\r\n.status {\r\n  display: inline !important;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  background-color: #868eae10;\r\n  padding: 4.5px 11.85px;\r\n  border-radius: 15px;\r\n}\r\n\r\n.status.Success {\r\n  background-color: #01b81a10;\r\n  color: #01b81a;\r\n}\r\n\r\n.status.warning {\r\n  background-color: #fa8b0c10;\r\n  color: #fa8b0c;\r\n}\r\n\r\n.status.error {\r\n  background-color: #FF0F0F10;\r\n  color: #FF0F0F;\r\n}\r\n\r\n.modal-video-close-btn {\r\n  cursor: pointer;\r\n}\r\n\r\nul {\r\n  list-style: outside none none;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n/* spacing classes */\r\n\r\n.m-0 {\r\n  margin: 0 !important;\r\n}\r\n\r\n.mb-0 {\r\n  margin-bottom: 0 !important;\r\n}\r\n\r\n.mb-20 {\r\n  margin-bottom: 20px !important;\r\n}\r\n\r\n.mb-25 {\r\n  margin-bottom: 25px !important;\r\n}\r\n\r\n.mb-30 {\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.pb-30 {\r\n  padding-bottom: 30px;\r\n}\r\n\r\n.pl-0 {\r\n  padding-left: 0 !important;\r\n}\r\n\r\n.mt-20 {\r\n  margin-top: 20px !important;\r\n}\r\n\r\n.mt-25 {\r\n  margin-top: 25px;\r\n}\r\n\r\n.mt-30 {\r\n  margin-top: 30px;\r\n}\r\n\r\n.pr-0 {\r\n  padding-right: 0 !important;\r\n}\r\n\r\n/* default card style */\r\n\r\n.ant-card {\r\n  box-shadow: 0 5px 20px rgba(173,181,217,.05);\r\n}\r\n\r\n.ant-card-body {\r\n  padding: 25px !important;\r\n}\r\n\r\n.ant-card-head {\r\n  padding-left: 25px !important;\r\n  padding-right: 25px !important;\r\n}\r\n\r\n.ant-card-head-title span {\r\n  display: inline-block;\r\n  margin-left: 15px;\r\n  font-size: 11px;\r\n  font-weight: 500;\r\n  color: #868eae;\r\n}\r\n\r\n.ant-card-head .ant-card-extra {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.ant-card-head .ant-card-extra:empty {\r\n  display: none;\r\n}\r\n\r\n.ant-card-head .ant-card-extra a {\r\n  color: #868eae;\r\n}\r\n\r\n.ant-card-extra .ant-dropdown-trigger {\r\n  line-height: 0;\r\n  order: 1;\r\n  margin-left: 20px;\r\n}\r\n\r\n.ninjadash-unresizable {\r\n  resize: none;\r\n}\r\n\r\n/* ninjaDash Delete Modal */\r\n\r\n.ninjaDash-delete-modal .ant-modal-header {\r\n  text-align: center;\r\n  padding: 22px 24px;\r\n}\r\n\r\n.ninjaDash-delete-modal .ant-modal-header .ant-modal-title {\r\n  font-size: 20px;\r\n  color: #ff0f0f;\r\n}\r\n\r\n.ninjaDash-delete-modal .ant-modal-body {\r\n  padding: 20px 24px;\r\n}\r\n\r\n.ninjaDash-delete-modal .ninjadash-delete-confirm {\r\n  text-align: center;\r\n}\r\n\r\n.ninjaDash-delete-modal .ninjadash-delete-confirm__action a {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 0 20px;\r\n  min-height: 32px;\r\n  border-radius: 3px;\r\n  color: #fff;\r\n  background-color: #01b81a;\r\n}\r\n\r\n/* NinjaDash Export Modal */\r\n.ninjadash_export-wrap .ninjadash-button-grp {\r\n  margin: -5px;\r\n}\r\n\r\n.ninjadash_export-wrap .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {\r\n  height: 50px !important;\r\n}\r\n\r\n.ninjadash_export-wrap .ant-select-single:not(.ant-select-customize-input) .ant-select-selection-item {\r\n  line-height: 50px !important;\r\n}\r\n\r\n.ninjadash_export-wrap .ninjadash-button-grp button {\r\n  min-height: 44px;\r\n}\r\n\r\n.ninjadash_export-wrap .ninjadash-button-grp .ant-btn {\r\n  margin: 5px;\r\n}\r\n\r\n/* ant radio group */\r\n\r\n.ant-radio-button-wrapper-checked {\r\n  color: #fff;\r\n}\r\n\r\n/* chart growth upward */\r\n\r\n.growth-downward p,\r\n.growth-upward p {\r\n  font-size: 14px;\r\n  color: #868eae;\r\n  margin: 0;\r\n}\r\n\r\n.growth-downward h1 sub svg,\r\n.growth-upward h1 sub svg {\r\n  position: relative;\r\n  top: 2px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  left: 5px;\r\n  bottom: 0;\r\n}\r\n\r\n/*\r\n.growth-downward h1, .growth-upward h1 {\r\n  font-size: 22px;\r\n  margin: 6px 0 0;\r\n} */\r\n\r\n.growth-downward h1 sub {\r\n  color: #FF0F0F;\r\n}\r\n\r\n.growth-upward h1 sub {\r\n  color: #01b81a;\r\n}\r\n\r\n/* Chart */\r\n\r\n.chart-label {\r\n  display: flex;\r\n}\r\n\r\n.chart-label .chart-label__single {\r\n  align-items: center;\r\n}\r\n\r\n.chart-label .chart-label__single:not(:last-child) {\r\n  margin-right: 40px;\r\n}\r\n\r\n.chart-label .chart-label__single p {\r\n  margin: 0;\r\n  color: #868eae;\r\n}\r\n\r\n/* revenue doughnut */\r\n\r\n.revenue-doughnut {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.revenue-doughnut>div {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.revenue-doughnut .rd-labels {\r\n  width: 100%;\r\n  margin-top: 30px;\r\n}\r\n\r\n.revenue-chat-percentage span {\r\n  display: block;\r\n}\r\n\r\n.revenue-chat-percentage span:not(:last-child) {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n/* progressbars */\r\n\r\n.ant-progress {\r\n  display: inline-flex !important;\r\n  align-items: center;\r\n}\r\n\r\n.ant-progress>div {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.ant-progress .ant-progress-outer {\r\n  margin-right: 0 !important;\r\n  padding-right: 0 !important;\r\n}\r\n\r\n.revenue-chat-percentage span {\r\n  display: block;\r\n  font-size: 13px;\r\n  color: #868eae;\r\n}\r\n\r\n.revenue-chat-percentage span:not(:last-child) {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.ant-progress-status-warning .ant-progress-bg {\r\n  background: #fa8b0c;\r\n}\r\n\r\n/* progress bars */\r\n\r\n.progress-primary .ant-progress-bg {\r\n  background: #8231D3;\r\n}\r\n\r\n.progress-secondary .ant-progress-bg {\r\n  background: #ff69a5;\r\n}\r\n\r\n.progress-success .ant-progress-bg {\r\n  background: #01b81a;\r\n}\r\n\r\n.progress-info .ant-progress-bg {\r\n  background: #00aaff;\r\n}\r\n\r\n.progress-warning .ant-progress-bg {\r\n  background: #fa8b0c;\r\n}\r\n\r\n.progress-danger .ant-progress-bg {\r\n  background: #FF0F0F;\r\n}\r\n\r\n/* color classes */\r\n\r\n.color-primary {\r\n  color: #8231D3;\r\n}\r\n\r\n.color-secondary {\r\n  color: #5840ff;\r\n}\r\n\r\n.color-info {\r\n  color: #00AAFF;\r\n}\r\n\r\n.color-warning {\r\n  color: #fa8b0c;\r\n}\r\n\r\n.color-success {\r\n  color: #01b81a;\r\n}\r\n\r\n.color-danger {\r\n  color: #FF0F0F;\r\n}\r\n\r\n.color-dark {\r\n  color: #0A0A0A;\r\n}\r\n\r\n.color-error {\r\n  color: #f5222d;\r\n}\r\n\r\n.color-gray {\r\n  color: #404040;\r\n}\r\n\r\n/* Button Styles */\r\n\r\n.button-example .ant-btn {\r\n  margin: 4px;\r\n}\r\n\r\n.button-example .ant-btn-group .ant-btn {\r\n  margin: 0;\r\n}\r\n\r\n.ant-btn.ant-btn-white {\r\n  color: #404040;\r\n  border-color: #e3e6ef;\r\n}\r\n\r\n.ant-btn.ant-btn-white svg {\r\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\r\n}\r\n\r\n.ant-btn.ant-btn-white:hover {\r\n  color: #8231D3;\r\n  background-color: #fff;\r\n  border-color: #8231D3;\r\n}\r\n\r\n.ant-btn.ant-btn-white:hover svg {\r\n  color: #8231D3;\r\n}\r\n\r\n.ant-btn-white:focus {\r\n  background-color: transparent !important;\r\n}\r\n\r\n.ant-btn.ant-btn-dashed {\r\n  border-width: 1px !important;\r\n  color: #090e30;\r\n}\r\n\r\n.ant-btn.ant-btn-dashed:hover {\r\n  color: #8231D3;\r\n  border: 1px dashed #8231D3;\r\n}\r\n\r\n.ant-btn-primary[disabled] {\r\n  color: #fff;\r\n  background: #8231D360;\r\n}\r\n\r\n.ant-btn-light[disabled] {\r\n  background: #fff;\r\n}\r\n\r\n.ant-btn-round.ant-btn-sm {\r\n  height: 38px;\r\n}\r\n\r\n.ant-btn-white[disabled] {\r\n  background-color: transparent;\r\n  opacity: 0.6;\r\n}\r\n\r\n.ant-btn-white[disabled]:hover {\r\n  color: #404040 !important;\r\n}\r\n\r\n.ant-btn-primary[disabled]:hover {\r\n  color: #fff !important;\r\n  background: #8231D360 !important;\r\n}\r\n\r\n.btn-icon {\r\n  padding: 0 13px;\r\n}\r\n\r\n.btn-inc,\r\n.btn-dec {\r\n  height: 38px;\r\n  width: 38px;\r\n  font-size: 20px;\r\n  padding: 0 12px !important;\r\n  border-radius: 10px !important;\r\n  border: 0 none;\r\n}\r\n\r\n.btn-inc:hover,\r\n.btn-dec:hover {\r\n  background: #8231D310 !important;\r\n  border: 0 none !important;\r\n}\r\n\r\n.btn-inc:hover i,\r\n.btn-inc:hover svg,\r\n.btn-dec:hover i,\r\n.btn-dec:hover svg {\r\n  color: #8231D3;\r\n}\r\n\r\n/* input styles */\r\n\r\n.ant-form-item-label>label {\r\n  font-weight: 500;\r\n}\r\n\r\n.ant-picker-input>input::placeholder {\r\n  color: #adb4d2 !important;\r\n}\r\n\r\n.ant-input-affix-wrapper,\r\n.ant-input {\r\n  border-radius: 6px;\r\n}\r\n\r\n.ant-input-affix-wrapper .ant-input-prefix {\r\n  margin-right: 8px;\r\n}\r\n\r\n.ant-input-affix-wrapper-lg .ant-input-lg {\r\n  font-size: 15px;\r\n}\r\n\r\n/* Calendar Styles */\r\n\r\n.ant-picker-calendar-header .ant-select-selector {\r\n  height: 32px !important;\r\n}\r\n\r\n.ant-picker-calendar-header .ant-select-selection-search-input {\r\n  height: 30px !important;\r\n}\r\n\r\n.ant-select-single .ant-select-selector .ant-select-selection-item {\r\n  line-height: 30px !important;\r\n}\r\n\r\n/* pagination */\r\n\r\n.ant-pagination .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {\r\n  height: 32px !important;\r\n}\r\n\r\n.ant-pagination-item-active {\r\n  background-color: #8231D3 !important;\r\n}\r\n\r\n.ant-pagination-item-active a {\r\n  color: #fff !important;\r\n}\r\n\r\n.ant-pagination .ant-pagination-options .ant-select-selection-item {\r\n  font-size: 13px;\r\n  line-height: 30px !important;\r\n}\r\n\r\n.ant-pagination .ant-pagination-options .ant-pagination-options-quick-jumper {\r\n  height: 30px;\r\n  line-height: 30px;\r\n}\r\n\r\n.ant-pagination .ant-pagination-options .ant-pagination-options-quick-jumper input {\r\n  line-height: 30px;\r\n  padding-top: 0;\r\n  padding-bottom: 0;\r\n}\r\n\r\n.ant-pagination .ant-pagination-prev,\r\n.ant-pagination .ant-pagination-next,\r\n.ant-pagination .ant-pagination-jump-prev,\r\n.ant-pagination .ant-pagination-jump-next,\r\n.ant-pagination .ant-pagination-item,\r\n.ant-pagination .ant-pagination-options .ant-select-selector {\r\n  border: 1px solid #f1f2f6 !important;\r\n  background-color: #fff;\r\n}\r\n\r\n.ant-pagination .ant-pagination-jump-prev .ant-pagination-item-ellipsis,\r\n.ant-pagination .ant-pagination-jump-next .ant-pagination-item-ellipsis {\r\n  color: #404040 !important;\r\n  line-height: 2.6;\r\n}\r\n\r\n.ant-pagination .ant-pagination-jump-prev .ant-pagination-item-link,\r\n.ant-pagination .ant-pagination-jump-next .ant-pagination-item-link {\r\n  display: block;\r\n}\r\n\r\n.ant-pagination-prev,\r\n.ant-pagination-next {\r\n  line-height: 28px !important;\r\n}\r\n\r\n.ant-pagination-prev .ant-pagination-item-link,\r\n.ant-pagination-next .ant-pagination-item-link {\r\n  border: 0 none !important;\r\n}\r\n\r\n.ant-pagination .ant-pagination-item a {\r\n  color: #404040;\r\n}\r\n\r\n.ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-ellipsis,\r\n.ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-ellipsis {\r\n  font-family: \"Jost\", sans-serif !important;\r\n}\r\n\r\n.ant-pagination .ant-select-single .ant-select-selector .ant-select-selection-item {\r\n  line-height: 30px !important;\r\n  color: #404040;\r\n}\r\n\r\n.ant-pagination .ant-select-single:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-search-input {\r\n  height: 100% !important;\r\n}\r\n\r\n.ant-pagination-item,\r\n.ant-pagination-options,\r\n.ant-pagination-prev,\r\n.ant-pagination-jump-prev,\r\n.ant-pagination-jump-next,\r\n.ant-pagination-next {\r\n  margin: 4px !important;\r\n}\r\n\r\n.ant-table-pagination {\r\n  margin-top: 30px !important;\r\n}\r\n\r\n.ant-table-thead>tr>th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {\r\n  display: none;\r\n}\r\n\r\n.ant-table table tr th.ant-table-selection-column,\r\n.ant-table table tr td.ant-table-selection-column {\r\n  padding: 0 16px;\r\n}\r\n\r\n/* Wizard Modal */\r\n.submission-successModal {\r\n  text-align: center;\r\n}\r\n\r\n.submission-successModal .icon-success {\r\n  width: 70px;\r\n  height: 70px;\r\n  border-radius: 50%;\r\n  margin: 0 auto 20px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: #fff;\r\n  border: 1px solid #01b81a;\r\n}\r\n\r\n.submission-successModal p {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.submission-successModal .icon-success svg {\r\n  color: #01b81a;\r\n}\r\n\r\n.submission-successModal .submission-action {\r\n  margin: 30px -5px -5px -5px;\r\n}\r\n\r\n.submission-successModal .submission-action button {\r\n  margin: 5px;\r\n  height: 38px;\r\n}\r\n\r\n/* Select */\r\n\r\n.ant-select:not(.ant-select-customize-input) .ant-select-selector {\r\n  border-color: #e3e6ef;\r\n  border-radius: 6px !important;\r\n}\r\n\r\n/* Tree Select */\r\n\r\n.ant-tree-select.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {\r\n  height: 42px !important;\r\n  line-height: 40px;\r\n}\r\n\r\n.ant-tree-select.ant-select-single:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-search-input {\r\n  height: 100% !important;\r\n}\r\n\r\n.ant-tree-select.ant-select-single .ant-select-selector .ant-select-selection-placeholder {\r\n  line-height: 40px !important;\r\n}\r\n\r\n/* radio style */\r\n\r\n.ant-radio-checked .ant-radio-inner {\r\n  border-width: 4px !important;\r\n}\r\n\r\n.ant-radio-inner::after {\r\n  content: none !important;\r\n}\r\n\r\n/* Statistics */\r\n\r\n.ant-statistic .ant-statistic-title {\r\n  color: #9299b8;\r\n}\r\n\r\n.ant-statistic .ant-statistic-content span {\r\n  font-size: 20px;\r\n}\r\n\r\n/* Steps */\r\n\r\n.steps-action.justify-content-center {\r\n  justify-content: center !important;\r\n}\r\n\r\n.ant-steps .ant-steps-item:not(.ant-steps-item-active)>.ant-steps-item-container[role=\"button\"]:hover .ant-steps-icon svg {\r\n  color: #8231D3;\r\n}\r\n\r\n/* rate */\r\n\r\n.ant-rate-star.ant-rate-star-zero span svg {\r\n  color: #c6d0dc;\r\n}\r\n\r\n.ant-rate-star:not(:last-child) {\r\n  margin-right: 2px !important;\r\n}\r\n\r\n/* result */\r\n\r\n.ant-result-icon {\r\n  margin-bottom: 20px !important;\r\n}\r\n\r\n.ant-result-title {\r\n  font-weight: 500;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.ant-result-extra {\r\n  height: 34px;\r\n  padding: 4px 10.72px;\r\n}\r\n\r\n.ant-result-content .ant-typography strong {\r\n  font-weight: 500;\r\n}\r\n\r\n.ant-result-content .ant-typography:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n/* form select */\r\n\r\n.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {\r\n  height: 38px !important;\r\n}\r\n\r\n.ant-select-single .ant-select-selector .ant-select-selection-item,\r\n.ant-select-single .ant-select-selector .ant-select-selection-placeholder {\r\n  line-height: 35px !important;\r\n}\r\n\r\n.ant-select-multiple .ant-select-selector {\r\n  padding-top: 2px !important;\r\n  padding-bottom: 2px !important;\r\n}\r\n\r\n.ninjadash-fullwidth-select {\r\n  width: 100%;\r\n}\r\n\r\n/* calendar style */\r\n\r\n.events {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.events .ant-badge-status {\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n  width: 100%;\r\n  text-overflow: ellipsis;\r\n  font-size: 12px;\r\n}\r\n\r\n.notes-month {\r\n  text-align: center;\r\n  font-size: 28px;\r\n}\r\n\r\n.notes-month section {\r\n  font-size: 28px;\r\n}\r\n\r\n/* Breadcrumb demo */\r\n\r\n.demo {\r\n  margin: 16px;\r\n}\r\n\r\n.demo-nav {\r\n  height: 30px;\r\n  line-height: 30px;\r\n  margin-bottom: 16px;\r\n  background: #f8f8f8;\r\n}\r\n\r\n.demo-nav a {\r\n  line-height: 30px;\r\n  padding: 0 8px;\r\n}\r\n\r\n.app-list {\r\n  margin-top: 16px;\r\n}\r\n\r\n/* Modal */\r\n\r\n.ant-modal .ant-modal-content {\r\n  border-radius: 10px;\r\n}\r\n\r\n.ant-modal .ant-modal-header {\r\n  border-radius: 10px 10px 0 0;\r\n}\r\n\r\n.ant-modal-body p:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.project-modal {\r\n  padding: 5px !important;\r\n}\r\n\r\n.project-modal .projects-members {\r\n  margin-top: -12px;\r\n}\r\n\r\n.project-modal .projects-members img {\r\n  margin: 6px;\r\n}\r\n\r\n.project-modal .ant-form-item-control-input {\r\n  margin-top: 10px;\r\n  min-height: auto;\r\n}\r\n\r\n.project-modal .ant-select-selector {\r\n  border-color: #e3e6ef;\r\n}\r\n\r\n.project-modal .ant-picker {\r\n  width: 100%;\r\n}\r\n\r\n.project-modal-footer {\r\n  padding: 10px !important;\r\n  text-align: left !important;\r\n}\r\n\r\n.ninjadash-addTask-modal {\r\n  max-width: 390px;\r\n}\r\n\r\n.ninjadash-addTask-modal .ant-modal-header {\r\n  border-bottom: 0 none;\r\n  padding-bottom: 0 !important;\r\n}\r\n\r\n.ninjadash-addTask-modal .ant-modal-header .ant-modal-title {\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  color: #0A0A0A;\r\n}\r\n\r\n.ninjadash-addTask-modal .ninjadash-addTask-modal-inner .ant-form-item {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.ninjadash-addTask-modal .ant-modal-header .ant-modal-close-x svg {\r\n  color: #9299b8;\r\n}\r\n\r\n.ninjadash-addTask-modal .ant-form-item-control-input {\r\n  min-height: 36px;\r\n}\r\n\r\n.ninjadash-addTask-modal input::placeholder,\r\n.ninjadash-addTask-modal textarea::placeholder {\r\n  color: #9299b8;\r\n}\r\n\r\n.ninjadash-addTask-modal input,\r\n.ninjadash-addTask-modal textarea {\r\n  padding: 6px 20px;\r\n  border-radius: 5px;\r\n}\r\n\r\n.ninjadash-addTask-modal textarea {\r\n  resize: none;\r\n  min-height: 125px;\r\n}\r\n\r\n.ninjadash-addTask-modal .ninjadash-modal-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  margin: -6px;\r\n}\r\n\r\n.ninjadash-addTask-modal .ninjadash-modal-actions button {\r\n  font-size: 14px;\r\n  margin: 6px;\r\n  height: 38px;\r\n  border-radius: 5px;\r\n}\r\n\r\n/* slider */\r\n\r\n.ant-slider-handle {\r\n  margin-top: -6px !important;\r\n}\r\n\r\n.ant-slider .ant-slider-rail,\r\n.ant-slider-track,\r\n.ant-slider .ant-slider-step {\r\n  height: 3px;\r\n}\r\n\r\n/* tags */\r\n\r\n.ant-tag {\r\n  font-weight: 600;\r\n  padding: 0 9.5px;\r\n}\r\n\r\n/* tabs */\r\n\r\n.ant-tabs-tab span {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n/* popover */\r\n\r\n.ant-popover {\r\n  position: fixed !important;\r\n  z-index: 99998 !important;\r\n}\r\n\r\n.ant-popover .ant-btn-sm {\r\n  font-size: 13px;\r\n}\r\n\r\n.ant-popover .ant-popover-inner {\r\n  padding: 15px;\r\n  box-shadow: 0 15px 25px rgba(146, 153, 184, .20);\r\n  border-radius: 6px;\r\n}\r\n\r\n.ant-popover-inner .ant-popover-title {\r\n  padding: 5px 10px 10px;\r\n}\r\n\r\n.ant-popover-inner .ant-popover-inner-content a {\r\n  color: #404040;\r\n}\r\n\r\n/* Drawer */\r\n\r\n.ant-drawer {\r\n  z-index: 99999;\r\n}\r\n\r\n/* Select Dropdwon */\r\n\r\n.ant-select-dropdown {\r\n  padding: 18px 0 !important;\r\n  box-shadow: 0 5px 20px #9299b820 !important;\r\n  border-radius: 0 0 6px 6px !important;\r\n}\r\n\r\n.ant-select-item {\r\n  min-height: 20px !important;\r\n  padding: 4px 12px !important;\r\n}\r\n\r\n.ant-select-item-group {\r\n  color: #9299b8;\r\n}\r\n\r\n.ant-select-item.ant-select-item-option-grouped {\r\n  padding-left: 25px !important;\r\n}\r\n\r\n.ant-select-dropdown .ant-select-item.ant-select-item-option-active {\r\n  background: #8231D305;\r\n}\r\n\r\n.ant-select-dropdown .ant-select-item.ant-select-item-option-selected .ant-select-item-option-content {\r\n  padding-left: 10px;\r\n}\r\n\r\n.ant-select-dropdown .ant-select-item.ant-select-item-option-selected {\r\n  color: #8231D3;\r\n  background: #8231D306;\r\n}\r\n\r\n.ant-select-dropdown .ant-select-item.ant-select-item-option-selected .ant-select-item-option-content {\r\n  color: #8231D3;\r\n  font-weight: 500;\r\n}\r\n\r\n.ant-select-dropdown .ant-select-item .ant-select-item-option-content {\r\n  transition: 0.3s;\r\n  color: #404040;\r\n}\r\n\r\n/* mail props dropdown */\r\n\r\n.mail-props {\r\n  padding: 10px 25px;\r\n  border: 0 none;\r\n  background: #fff;\r\n  margin-bottom: 0;\r\n  /* box-shadow: 0 5px 40px rgba(146, 153, 184, 0.25); */\r\n}\r\n\r\n.mail-props li {\r\n  display: flex;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.mail-props li span:first-child {\r\n  margin-right: 50px;\r\n  min-width: 40px;\r\n}\r\n\r\n.mail-props li span:last-child {\r\n  color: #404040;\r\n}\r\n\r\n.mail-props li:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.mail-props li span {\r\n  color: #9299b8;\r\n}\r\n\r\n/* Basic Dropdwon */\r\n\r\n.ant-dropdown {\r\n  box-shadow: 0 5px 30px #9299b820 !important;\r\n}\r\n\r\n.ant-dropdown.wide-dropdwon {\r\n  min-width: 140px !important;\r\n}\r\n\r\n.ant-dropdown.wide-dropdwon.kanbanCard-more {\r\n  min-width: 220px !important;\r\n  box-shadow: 0 17px 20px #9299b820;\r\n}\r\n\r\n.ant-dropdown.wide-dropdwon.kanbanCard-more a {\r\n  padding: 10px 24px;\r\n}\r\n\r\n.ant-dropdown-menu {\r\n  min-width: 200px;\r\n  border-radius: 0 0 5px 5px;\r\n  box-shadow: 0 0;\r\n}\r\n\r\n.ant-dropdown-menu li {\r\n  color: #404040;\r\n  padding: 5px 25px;\r\n}\r\n\r\n.ant-dropdown-menu li:hover {\r\n  background-color: #8231D305;\r\n}\r\n\r\n.ninjadash-top-dropdown .ninjadash-top-dropdown__title {\r\n  background: #f4f5f7;\r\n  width: 100%;\r\n  margin-bottom: 12px;\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  min-height: 50px;\r\n  display: inline-flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.ninjadash-top-dropdown {\r\n  width: 340px;\r\n}\r\n\r\n.ninjadash-top-dropdown .ninjadash-top-dropdown__nav {\r\n  height: 260px;\r\n}\r\n\r\n.ninjadash-top-dropdown .ninjadash-top-dropdown__nav.notification-list {\r\n  padding: 0 10px;\r\n}\r\n\r\n.ninjadash-top-dropdown .ninjadash-top-dropdown__nav li {\r\n  width: 100%;\r\n}\r\n\r\n.ninjadash-top-dropdown .ninjadash-top-dropdown__nav li a {\r\n  padding: 13px 10px;\r\n  position: relative;\r\n  width: 100%;\r\n}\r\n\r\n.ninjadash-top-dropdown .ninjadash-top-dropdown__nav li:last-child {\r\n  margin: 0;\r\n}\r\n\r\n.ninjadash-top-dropdown a.btn-seeAll {\r\n  position: relative;\r\n  width: calc(100% + 30px);\r\n  left: -15px;\r\n  right: -15px;\r\n  height: calc(100% + 15px);\r\n  bottom: -15px;\r\n  text-align: center;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  color: #8231D3;\r\n  padding: 15px 0;\r\n  border-radius: 0 0 6px 6px;\r\n  justify-content: center;\r\n  background: #fff;\r\n  transition: 0.3s;\r\n}\r\n\r\n.ninjadash-top-dropdown a.btn-seeAll:before {\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  box-shadow: 0 -15px 20px #9299b808;\r\n  z-index: 1;\r\n  content: \"\";\r\n}\r\n\r\n.ninjadash-top-dropdown .ninjadash-top-dropdown__nav li a.btn-seeAll:hover:after {\r\n  box-shadow: 0 0;\r\n}\r\n\r\n.ninjadash-top-dropdown .ninjadash-top-dropdown__nav li a:hover {\r\n  background: #fff;\r\n}\r\n\r\n.ninjadash-top-dropdown .ninjadash-top-dropdown__nav li a:hover:after {\r\n  opacity: 1;\r\n  visibility: visible;\r\n}\r\n\r\n.ninjadash-top-dropdown .ninjadash-top-dropdown__nav li a:hover figcaption h1 {\r\n  color: #8231D3;\r\n}\r\n\r\n.ninjadash-top-dropdown .ninjadash-top-dropdown__nav li a:after {\r\n  position: absolute;\r\n  left: -15px;\r\n  right: -15px;\r\n  top: 0;\r\n  width: calc(100% + 30px);\r\n  height: 100%;\r\n  box-shadow: 0 15px 50px #9299b820;\r\n  z-index: 1;\r\n  content: \"\";\r\n  opacity: 0;\r\n  visibility: hidden;\r\n}\r\n\r\n.ninjadash-top-dropdown .ninjadash-top-dropdown__content {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  width: 100%;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.ninjadash-top-dropdown .ninjadash-top-dropdown__content .notification-icon {\r\n  width: 39.2px;\r\n  height: 32px;\r\n  margin-right: 15px;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.ninjadash-top-dropdown .ninjadash-top-dropdown__content .notification-icon.bg-primary {\r\n  background: #8231D315;\r\n  color: #8231D3;\r\n}\r\n\r\n.ninjadash-top-dropdown .ninjadash-top-dropdown__content .notification-icon.bg-secondary {\r\n  background: #5840FF15;\r\n  color: #5840FF;\r\n}\r\n\r\n.ninjadash-top-dropdown .ninjadash-top-dropdown__content .notification-icon svg {\r\n  width: 18px;\r\n  height: 18px;\r\n}\r\n\r\n.ninjadash-top-dropdown .ninjadash-top-dropdown__content .notification-content {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.ninjadash-top-dropdown .notification-text h1 {\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  color: #404040;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.ninjadash-top-dropdown .notification-text h1 span {\r\n  color: #8231D3;\r\n  font-weight: 500;\r\n  padding-left: 0;\r\n}\r\n\r\n.ninjadash-top-dropdown .notification-text p {\r\n  font-size: 12px;\r\n  color: #adb4d2;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.ninjadash-top-dropdown .ninjadash-top-dropdown__content img {\r\n  max-width: 40px;\r\n}\r\n\r\n.ninjadash-top-dropdown .ninjadash-top-dropdown__content figcaption {\r\n  margin: -4px 15px 0;\r\n}\r\n\r\n.ninjadash-top-dropdown .ninjadash-top-dropdown__content figcaption .ant-badge-count {\r\n  font-size: 8px;\r\n  min-width: 16px;\r\n  width: 16px;\r\n  height: 16px;\r\n  line-height: 16px;\r\n  border-radius: 8px;\r\n}\r\n\r\n.ninjadash-top-dropdown .ninjadash-top-dropdown__content figcaption p.ant-scroll-number-only-unit.current {\r\n  height: 15px;\r\n}\r\n\r\n.ninjadash-top-dropdown .ninjadash-top-dropdown__content figcaption h1 {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.ninjadash-top-dropdown .ninjadash-top-dropdown__content figcaption h1 span {\r\n  font-size: 12px;\r\n  font-weight: 400;\r\n}\r\n\r\n.ninjadash-top-dropdown .ninjadash-top-dropdown__content figcaption p {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.add-file-dropdown a {\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n}\r\n\r\n.add-file-dropdown a svg {\r\n  width: 14px;\r\n}\r\n\r\n.folder-dropdown {\r\n  min-width: 200px !important;\r\n}\r\n\r\n/* Tooltip Styles */\r\n\r\n.ant-tooltip .ant-tooltip-inner {\r\n  min-height: 40px;\r\n  padding: 6px 20px;\r\n  font-size: 14px;\r\n  color: #404040;\r\n  background-color: #fff;\r\n  border-radius: 3px;\r\n  display: flex;\r\n  align-items: center;\r\n  border: 1px solid #f1f2f6;\r\n  box-shadow: 0 8px 15px #9299b815;\r\n}\r\n\r\n.ant-tooltip .ant-tooltip-arrow:after {\r\n  position: absolute;\r\n  left: 50%;\r\n  top: 30px;\r\n  transform: translateX(-50%);\r\n  width: 13px;\r\n  height: 13px;\r\n  background: #fff;\r\n  content: \"\";\r\n}\r\n\r\n.ant-tooltip .ant-tooltip-arrow .ant-tooltip-arrow-content {\r\n  width: 14px;\r\n  height: 14px;\r\n  top: 3px;\r\n  background: #fff;\r\n  z-index: 98;\r\n  --antd-arrow-background-color: #fff;\r\n}\r\n\r\n.ant-tooltip .ant-tooltip-arrow .ant-tooltip-arrow-content:before {\r\n  position: static;\r\n}\r\n\r\n.ant-tooltip-placement-bottom .ant-tooltip-arrow .ant-tooltip-arrow-content {\r\n  border: 1px solid #e3e6ef;\r\n  box-shadow: 0 0;\r\n}\r\n\r\n.ant-tooltip-placement-bottom .ant-tooltip-arrow {\r\n  top: -4.071068px;\r\n}\r\n\r\n.ant-slider-tooltip.ant-tooltip-placement-top .ant-tooltip-arrow {\r\n  transform: translateY(80%) translateX(-50%);\r\n}\r\n\r\n/* Badge Styles */\r\n\r\n.ant-badge.badge-success .ant-badge-count {\r\n  background: #01b81a;\r\n}\r\n\r\n.badge {\r\n  font-size: 11px;\r\n  font-weight: 500;\r\n  padding: 0 6.5px;\r\n  height: 20px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-radius: 10px;\r\n}\r\n\r\n.badge .ant-badge-count {\r\n  box-shadow: 0 0;\r\n}\r\n\r\n.badge.badge-primary {\r\n  background: #8231D315;\r\n  color: #8231D3;\r\n}\r\n\r\n/* Cascade Styles */\r\n\r\n.custom-cascade-render .ant-cascader-picker {\r\n  width: 100%;\r\n}\r\n\r\n.ant-cascader-picker input::placeholder {\r\n  color: #adb4d2;\r\n}\r\n\r\n/* Comment Styles */\r\n\r\n.ant-comment-actions li {\r\n  margin-bottom: 0 !important;\r\n}\r\n\r\n/* Radio Vertical Button */\r\n\r\n.ant-radio-vertical .ant-radio-wrapper {\r\n  display: block;\r\n}\r\n\r\n.ant-radio-vertical .ant-radio-wrapper:not(:last-child) {\r\n  margin-bottom: 14px;\r\n}\r\n\r\n/* Select Tree */\r\n\r\n.ant-select-tree-list .ant-select-tree-node-content-wrapper:hover {\r\n  background-color: #bae7ff !important;\r\n}\r\n\r\n.ant-select-tree-list .ant-select-arrow svg {\r\n  font-size: 10px;\r\n}\r\n\r\n.ant-tree-select.ant-select-multiple .ant-select-selection-item {\r\n  border: 0 none;\r\n  border-radius: 3px;\r\n  background: #f4f5f7;\r\n  color: #404040;\r\n  font-weight: 500;\r\n}\r\n\r\n/* Ant Switch */\r\n\r\n.ant-switch:after {\r\n  width: 14px !important;\r\n  height: 14px !important;\r\n}\r\n\r\n.ant-switch-small:after {\r\n  width: 10px !important;\r\n  height: 10px !important;\r\n}\r\n\r\n/* Time Picker */\r\n\r\n.ant-picker {\r\n  min-width: 250px;\r\n}\r\n\r\n/* Input Affix */\r\n\r\n.ant-input-affix-wrapper>input.ant-input {\r\n  padding-left: 5px;\r\n}\r\n\r\n.ant-input-affix-wrapper .ant-input-prefix svg {\r\n  color: #e3e6ef;\r\n}\r\n\r\n.ant-input-affix-wrapper {\r\n  padding: 8px 20px;\r\n}\r\n\r\n/* Space Item */\r\n\r\n.ant-space-item .ant-btn span {\r\n  font-size: 14px;\r\n}\r\n\r\n/* Pop confirm */\r\n\r\n.pop-confirm .ant-btn {\r\n  max-width: 90px;\r\n  padding: 0px 35.5px;\r\n  height: 44px;\r\n}\r\n\r\n.pop-confirm-top {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.pop-confirm-bottom {\r\n  margin-top: 10px;\r\n}\r\n\r\n.pop-confirm-top .ant-btn:not(:last-child),\r\n.pop-confirm-bottom .ant-btn:not(:last-child) {\r\n  margin-right: 10px;\r\n}\r\n\r\n.pop-confirm-left .ant-btn:not(:last-child),\r\n.pop-confirm-right .ant-btn:not(:last-child) {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n/* Ant Upload */\r\n\r\n.ant-upload .ant-btn {\r\n  font-size: 14px;\r\n  border-radius: 5px;\r\n}\r\n\r\n.ant-upload.ant-upload-select-picture-card {\r\n  border-color: #e3e6ef !important;\r\n  border-radius: 5px !important;\r\n  background-color: #f8f9fb !important;\r\n}\r\n\r\n.ant-upload.ant-upload-select-picture-card .anticon {\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.ant-upload .anticon svg {\r\n  color: #9299b8;\r\n}\r\n\r\n.ant-upload-list {\r\n  margin-top: 10px !important;\r\n}\r\n\r\n.ninjadash-upload-basic .ant-upload.ant-upload-select {\r\n  width: 100%;\r\n  border: 1px solid #e3e6ef;\r\n  border-radius: 4px;\r\n}\r\n\r\n.ninjadash-upload-basic .ant-upload.ant-upload-select .ant-upload {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.ninjadash-upload-basic .ninjadash-upload-text {\r\n  font-size: 14px;\r\n  color: #9299b8;\r\n  padding-left: 15px;\r\n}\r\n\r\nhtml[dir=\"rtl\"] .ninjadash-upload-basic .ninjadash-upload-text {\r\n  padding-left: 0px;\r\n  padding-right: 15px;\r\n}\r\n\r\n.ninjadash-upload-basic .ninjadash-upload-browse {\r\n  font-size: 14px;\r\n  color: #9299b8;\r\n  display: inline-block;\r\n  padding: 14px 23px;\r\n  border-left: 1px solid #e3e6ef;\r\n}\r\n\r\nhtml[dir=\"rtl\"] .ninjadash-upload-basic .ninjadash-upload-browse {\r\n  border-left: 0 none;\r\n  border-right: 1px solid #e3e6ef;\r\n}\r\n\r\n.ant-modal-wrap-rtl .ninjadash-event-details-modal .ant-modal-close {\r\n  left: 10px;\r\n}\r\n\r\n.ant-card.ninjadash-upload-form .ant-card-body {\r\n  padding-bottom: 15px !important;\r\n}\r\n\r\n/* Ant Picker */\r\n\r\n.ant-picker {\r\n  border-color: #e3e6ef;\r\n}\r\n\r\n/* Ant Dropdown */\r\n\r\n.ant-dropdown {\r\n  box-shadow: 0 5px 20px #9299b820;\r\n  background: #fff;\r\n  border-radius: 6px;\r\n  border: 0 none;\r\n}\r\n\r\n.ant-dropdown a {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 8px 24px;\r\n  font-weight: 400;\r\n  color: #404040;\r\n}\r\n\r\n.ant-dropdown a i,\r\n.ant-dropdown a svg,\r\n.ant-dropdown a img {\r\n  margin-right: 8px;\r\n  width: 14px;\r\n  height: 14px;\r\n}\r\n\r\n.ant-dropdown div {\r\n  box-shadow: 0 0;\r\n  border-radius: 5px;\r\n}\r\n\r\n/* Picker Under Input */\r\n\r\n.ant-form-item-control-input .ant-picker {\r\n  padding: 0 12px 0 12px;\r\n  min-height: 38px;\r\n  border-color: #e3e6ef;\r\n}\r\n\r\n/* Leaflet COntainer */\r\n\r\n.leaflet-container {\r\n  z-index: 0;\r\n}\r\n\r\n/* Table Bordered*/\r\n.table-bordered .ant-table-thead>tr>th {\r\n  background: #fff;\r\n  border-top: 1px solid #f1f2f6;\r\n}\r\n\r\n.table-bordered .ant-table-tbody>tr>td {\r\n  border-color: #f1f2f6 !important;\r\n}\r\n\r\n.table-bordered .ant-table-thead tr th,\r\n.table-bordered .ant-table-tbody tr td {\r\n  padding: 16px 25px;\r\n}\r\n\r\n.table-bordered .ant-table-thead tr th:last-child,\r\n.table-bordered .ant-table-tbody tr td:last-child {\r\n  text-align: right;\r\n}\r\n\r\n/* Table Responsive */\r\n\r\n.table-responsive .ant-table-content {\r\n  display: block;\r\n  width: 100%;\r\n  overflow-x: auto;\r\n}\r\n\r\n.table-responsive .ant-table-content .ant-table-cell {\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Rich TextEditor  */\r\n\r\n.RichTextEditor__root___2QXK- {\r\n  border: 0 none !important;\r\n}\r\n\r\n.RichTextEditor__root___2QXK- .EditorToolbar__root___3_Aqz {\r\n  margin: 0;\r\n  border-color: #f1f2f6;\r\n}\r\n\r\n.RichTextEditor__root___2QXK- .ButtonWrap__root___1EO_R button {\r\n  padding: 0;\r\n  border: 0 none;\r\n  background: #fff;\r\n  margin-right: 8px;\r\n}\r\n\r\n.RichTextEditor__root___2QXK- .Dropdown__root___3ALmx .Dropdown__value___34Py9 {\r\n  border: 0 none;\r\n}\r\n\r\n.RichTextEditor__root___2QXK- .Dropdown__root___3ALmx select {\r\n  border-right-width: 0px;\r\n  direction: ltr;\r\n}\r\n\r\n.RichTextEditor__editor___1QqIU .DraftEditor-editorContainer {\r\n  border: 0 none;\r\n}\r\n\r\n/* ChatBox Dropdwon */\r\n\r\n.atbd-chatbox__messageControl {\r\n  min-width: 210px;\r\n}\r\n\r\n.atbd-chatbox__messageControl ul {\r\n  margin: 0;\r\n  padding: 10px 0;\r\n}\r\n\r\n.atbd-chatbox__messageControl ul li a {\r\n  padding: 4px 24px;\r\n}\r\n\r\n.atbd-chatbox__emoji {\r\n  margin: -4.48px 0;\r\n  padding: 0 10px;\r\n}\r\n\r\n.atbd-chatbox__emoji ul {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.atbd-chatbox__emoji ul li {\r\n  display: inline-block;\r\n}\r\n\r\n.atbd-chatbox__emoji ul li a {\r\n  display: block;\r\n  font-size: 20px;\r\n  padding: 4px 7px;\r\n  background: #fff;\r\n}\r\n\r\n.atbd-chatbox__emoji ul li a:hover {\r\n  background-color: transparent;\r\n}\r\n\r\n.atbd-chatbox__emoji ul li a svg {\r\n  margin: 0;\r\n}\r\n\r\n.rdrMonths {\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.ant-space {\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.ant-menu .ant-menu-submenu .ant-menu-submenu-title {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.ant-menu-submenu.ant-menu-submenu-inline .ant-menu-submenu-title,\r\n.ant-menu-item {\r\n  display: inline-flex;\r\n}\r\n\r\n.ant-menu-submenu-popup {\r\n  z-index: 105;\r\n}\r\n\r\n.ant-menu-submenu-popup .ant-menu-sub {\r\n  padding: 8px 0;\r\n}\r\n\r\n.ant-menu-submenu-popup .ant-menu-submenu.ant-menu-submenu-inline .ant-menu-submenu-title,\r\n.ant-menu-submenu-popup .ant-menu-item {\r\n  display: block;\r\n}\r\n\r\n.ant-menu-submenu-popup .ant-menu-item {\r\n  margin-bottom: 0 !important;\r\n}\r\n\r\n.ant-menu-sub.ant-menu-vertical {\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.ant-menu-sub.ant-menu-vertical .ant-menu-item a {\r\n  color: #404040;\r\n}\r\n\r\n/* Ninjadash Header More */\r\n.ninjadash-header-more .ninjadash-nav-actions__searchbar {\r\n  display: none;\r\n}\r\n\r\n/* page heading */\r\n\r\n.ant-page-header.header-boxed {\r\n  padding: 26px 180px 26px 180px !important;\r\n}\r\n\r\n.ant-page-header-heading {\r\n  align-items: center;\r\n}\r\n\r\n.ant-page-header-heading-title {\r\n  text-transform: capitalize;\r\n}\r\n\r\n.ant-page-header-heading-sub-title {\r\n  position: relative;\r\n  top: 2px;\r\n}\r\n\r\n/* Swiper Sldier */\r\n\r\n.swiper-container {\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  position: relative;\r\n  overflow: hidden;\r\n  list-style: none;\r\n  padding: 0;\r\n  z-index: 1;\r\n}\r\n\r\n/* Antd drag & drop */\r\n\r\n.row-dragging {\r\n  /* background: #fafafa; */\r\n  /* border: 1px solid #ccc; */\r\n  box-shadow: 0 15px 50px #9299b820;\r\n  display: flex;\r\n}\r\n\r\n.row-dragging tr {\r\n  box-shadow: 0 15px 50px #9299b820;\r\n}\r\n\r\n.row-dragging td {\r\n  padding: 16px;\r\n  color: #000;\r\n  position: relative;\r\n  z-index: 9999;\r\n  opacity: 0.5;\r\n  vertical-align: middle;\r\n}\r\n\r\n.row-dragging td .ant-checkbox-checked .ant-checkbox-inner {\r\n  background-color: #01b81a;\r\n  border-color: #01b81a;\r\n}\r\n\r\n.row-dragging td .todos-action,\r\n.row-dragging td .table-actions {\r\n  display: none;\r\n}\r\n\r\n.row-dragging td .user-info figcaption {\r\n  display: none;\r\n}\r\n\r\n.row-dragging td .feather-move,\r\n.row-dragging td .drag_email,\r\n.row-dragging td .drag_company,\r\n.row-dragging td .drag_designation,\r\n.row-dragging td .drag_join-date,\r\n.row-dragging td .active {\r\n  display: inline-block;\r\n  margin-top: 10px;\r\n}\r\n\r\n.row-dragging .drag-visible {\r\n  visibility: visible;\r\n}\r\n\r\n/* Ninjadash Event Details Modal */\r\n.ninjadash-event-details-modal .ant-modal-content {\r\n  border-radius: 8px;\r\n}\r\n\r\n.ninjadash-event-details-modal .ant-modal-close {\r\n  top: 12px;\r\n  right: 10px;\r\n}\r\n\r\n.ninjadash-event-details-modal .ant-modal-close-x svg {\r\n  width: 14px;\r\n  height: 14px;\r\n  color: #ffffff75;\r\n}\r\n\r\n.ninjadash-event-details-modal .ant-modal-close-x {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 36px;\r\n  height: 36px;\r\n  border-radius: 50%;\r\n  line-height: 1;\r\n  background-color: transparent;\r\n}\r\n\r\n.ninjadash-event-details-modal .ant-modal-close-x:hover {\r\n  background-color: #ffffff15;\r\n}\r\n\r\n.ninjadash-event-details-modal .ant-modal-close-x:hover svg {\r\n  color: #ffffff;\r\n}\r\n\r\n.ninjadash-event-details-modal.ninjadash-event-details-modal-primary .ant-modal-header {\r\n  background-color: #8231D3;\r\n}\r\n\r\n.ninjadash-event-details-modal.ninjadash-event-details-modal-secondary .ant-modal-header {\r\n  background-color: #5840ff;\r\n}\r\n\r\n.ninjadash-event-details-modal.ninjadash-event-details-modal-success .ant-modal-header {\r\n  background-color: #01b81a;\r\n}\r\n\r\n.ninjadash-event-details-modal.ninjadash-event-details-modal-info .ant-modal-header {\r\n  background-color: #00aaff;\r\n}\r\n\r\n.ninjadash-event-details-modal.ninjadash-event-details-modal-warning .ant-modal-header {\r\n  background-color: #fa8b0c;\r\n}\r\n\r\n.ninjadash-event-details-modal.ninjadash-event-details-modal-danger .ant-modal-header {\r\n  background-color: #ff0f0f;\r\n}\r\n\r\n.ninjadash-event-details-modal.ninjadash-event-details-modal-dark .ant-modal-header {\r\n  background-color: #090e30;\r\n}\r\n\r\n.ninjadash-event-details-modal .ant-modal-header {\r\n  padding: 19px 24px;\r\n  border-radius: 8px 8px 0 0;\r\n}\r\n\r\n.ninjadash-event-details-modal .ant-modal-header .ant-modal-title {\r\n  color: #fff;\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n}\r\n\r\n/* File Export Import Modal */\r\n.ninjadash-export-wrap .ant-modal {\r\n  width: 390px !important;\r\n}\r\n\r\n.ninjadash-export-wrap .ant-modal .ant-modal-header {\r\n  border-bottom: 0 none;\r\n  padding: 18px 30px 0 30px;\r\n}\r\n\r\n.ninjadash-export-wrap .ant-modal .ant-modal-body {\r\n  padding: 25px 30px 30px 30px;\r\n}\r\n\r\n.ninjadash-export-wrap .ant-modal .ninjadash-button-grp {\r\n  text-align: right;\r\n}\r\n\r\n.ninjadash-export-wrap .ant-modal .ninjadash-button-grp {\r\n  margin: 20px -8px -8px -8px;\r\n}\r\n\r\n.ninjadash-export-wrap .ant-modal .ninjadash-button-grp button {\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  text-align: right;\r\n  height: 40px;\r\n  padding: 0 16px;\r\n  margin: 8px;\r\n}\r\n\r\n.ninjadash-export-wrap .ant-modal .ninjadash-button-grp button.ant-btn-white {\r\n  color: #9299b8 !important;\r\n}\r\n\r\n.ninjadash-export-wrap .ant-form-item-control-input {\r\n  min-height: 36px;\r\n}\r\n\r\n.ninjadash-export-wrap .ant-form-item-control-input input {\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  padding: 6px 20px;\r\n  border-radius: 5px;\r\n  color: #9299b8;\r\n}\r\n\r\n.ninjadash-export-wrap .ant-select-single {\r\n  width: 100% !important;\r\n}\r\n\r\n.ninjadash-export-wrap .ant-form .ant-form-item {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.ninjadash-export-wrap .ant-select-single .ant-select-selector {\r\n  padding: 0 20px;\r\n  border-color: #e3e6ef !important;\r\n}\r\n\r\n.ninjadash-create-file .ninjadash-button-grp {\r\n  text-align: right;\r\n}\r\n\r\n.ninjadash-create-file .ant-modal {\r\n  width: 390px !important;\r\n}\r\n\r\n.ninjadash-create-file .ant-modal .ant-form-item {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.ninjadash-create-file .ant-modal-header {\r\n  border-bottom: 0 none;\r\n  padding-bottom: 6px;\r\n}\r\n\r\n.ninjadash-create-file .ninjadash-button-grp button {\r\n  height: 40px;\r\n  border-radius: 5px;\r\n  margin: 5px;\r\n}\r\n\r\n.ninjadash-create-file .ant-form-item-control-input {\r\n  border-radius: 5px;\r\n}\r\n\r\n.ninjadash-create-file .ant-form-item-control-input input {\r\n  border: 1px solid #e3e6ef;\r\n}\r\n\r\n/* Task Modal */\r\n.ninjadash-task-details .ant-modal-content .ant-modal-close {\r\n  top: 10px;\r\n}\r\n\r\n.ninjadash-task-details .ant-modal-header {\r\n  border-bottom: 0 none;\r\n  padding: 30px 30px 0;\r\n}\r\n\r\n.ninjadash-task-details .ant-modal {\r\n  width: 600px !important;\r\n}\r\n\r\n.ninjadash-task-details .ant-modal-header .ant-modal-title h4 {\r\n  font-size: 20px;\r\n  font-weight: 500;\r\n  color: #0A0A0A;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.ninjadash-task-details .ant-modal-header .ant-modal-title .sub-text {\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  color: #868eae;\r\n}\r\n\r\n.ninjadash-task-details .ninjadash-task-details-modal .ninjadash-task-details__label {\r\n  font-size: 16px;\r\n  display: block;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.ninjadash-task-details .ninjadash-task-details-modal .ninjadash-task-details-modal__description textarea {\r\n  padding: 10px 20px;\r\n  min-height: 88px;\r\n  width: 100%;\r\n  border: 0 none;\r\n  border-radius: 4px;\r\n  background-color: #f4f5f7;\r\n  resize: none;\r\n}\r\n\r\n.ninjadash-task-details .ninjadash-task-details-modal .ninjadash-task-details-modal__description textarea:focus {\r\n  outline: none;\r\n}\r\n\r\n.ninjadash-task-details .ninjadash-task-details-modal .ninjadash-task-details-modal__description textarea::placeholder {\r\n  color: #404040;\r\n  font-size: 15px;\r\n}\r\n\r\n.ninjadash-task-details .ant-modal-body {\r\n  padding: 14px 30px 30px 30px;\r\n}\r\n\r\n.ninjadash-task-details .ant-modal-body .ninjadash-checklist-block {\r\n  margin-top: 26px;\r\n}\r\n\r\n.ninjadash-task-details .ant-modal-body .ninjadash-checklist-block .addChecklist-wrap {\r\n  position: relative;\r\n}\r\n\r\n.ninjadash-task-details .ant-modal-body .ninjadash-checklist-block .addChecklist-form {\r\n  position: absolute;\r\n  width: 240px;\r\n  padding: 18px;\r\n  left: 0;\r\n  top: 50px;\r\n  box-shadow: 0 15px 30px #9299bb30;\r\n  background-color: #fff;\r\n  border: 1px solid #e3e6ef;\r\n  border-radius: 6px;\r\n  z-index: 222;\r\n}\r\n\r\nhtml[dir=\"rtl\"] .ninjadash-task-details .ant-modal-body .ninjadash-checklist-block .addChecklist-form {\r\n  left: auto;\r\n  right: 0;\r\n}\r\n\r\n.ninjadash-task-details .ant-modal-body .ninjadash-checklist-block .addChecklist-form .add-checklist {\r\n  padding: 10px;\r\n  border-radius: 4px;\r\n  background-color: #fff;\r\n  width: 100%;\r\n  height: 38px;\r\n  border: 1px solid #e3e6ef;\r\n}\r\n\r\n.ninjadash-task-details .ant-modal-body .ninjadash-checklist-block .addChecklist-form .addChecklist-form-action {\r\n  margin-top: 15px;\r\n}\r\n\r\n.ninjadash-task-details .ant-modal-body .ninjadash-checklist-block .addChecklist-form .addChecklist-form-action a {\r\n  position: relative;\r\n  top: 3px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  line-height: 1;\r\n}\r\n\r\n.ninjadash-task-details .ant-modal-body .ninjadash-checklist-block .addChecklist-form .addChecklist-form-action a svg {\r\n  color: #9299bb;\r\n}\r\n\r\n.ninjadash-task-details .ant-modal-body .ninjadash-checklist-block .addChecklist-form .addChecklist-form-action .btn-add {\r\n  margin-right: 15px;\r\n}\r\n\r\nhtml[dir=\"rtl\"] .ninjadash-task-details .ant-modal-body .ninjadash-checklist-block .addChecklist-form .addChecklist-form-action .btn-add {\r\n  margin-left: 15px;\r\n  margin-right: 0;\r\n}\r\n\r\n.ninjadash-task-details .ant-modal-body .ninjadash-checklist-block button {\r\n  height: 38px;\r\n  padding: 0px 18.37px;\r\n}\r\n\r\n.ninjadash-task-details .ant-modal-body .ninjadash-checklist-row {\r\n  margin-top: 26px;\r\n}\r\n\r\n.ninjadash-task-details .ant-modal-body .ninjadash-checklist-row .ninjadash-checklist-item:not(:last-child) {\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.ninjadash-task-details .ant-modal-body .ninjadash-checklist-row .ninjadash-checklist-item__top {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.ninjadash-task-details .ant-modal-body .ninjadash-checklist-row .ninjadash-checklist-item__top button {\r\n  padding: 0px 16.32px;\r\n  color: #525768;\r\n  background-color: #f4f5f7;\r\n}\r\n\r\n.ninjadash-task-details .ant-modal-body .ninjadash-checklist-row .ninjadash-checklist-item__title {\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  color: #090e30;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.ninjadash-task-details .ant-modal-body .ninjadash-checklist-row .ninjadash-checklist__progress .ant-progress-inner .ant-progress-bg {\r\n  height: 5px !important;\r\n  background-color: #01b81a;\r\n}\r\n\r\n.ninjadash-task-details .ant-modal-body .ninjadash-checklist-row .ninjadash-checklist__progress .ant-progress .ant-progress-text {\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  order: -1;\r\n  margin: 0 10px 0 0;\r\n}\r\n\r\nhtml[dir=\"rtl\"] .ninjadash-task-details .ant-modal-body .ninjadash-checklist-row .ninjadash-checklist__progress .ant-progress .ant-progress-text {\r\n  margin: 0 0 0 10px;\r\n}\r\n\r\n.ninjadash-task-details .ant-modal-body .ninjadash-checklist-tasks {\r\n  margin: 5px 0 5px 0;\r\n}\r\n\r\n.ninjadash-task-details .ant-modal-body .ninjadash-checklist-tasks .ant-checkbox-wrapper .ant-checkbox-inner {\r\n  width: 18px;\r\n  height: 18px;\r\n  border-color: #c6d0dc;\r\n}\r\n\r\n.ninjadash-task-details .ant-modal-body .ninjadash-checklist-tasks .ant-checkbox-wrapper .ant-checkbox-checked .ant-checkbox-inner {\r\n  background-color: #01b81a;\r\n}\r\n\r\n.ninjadash-task-details .ant-modal-body .ninjadash-checklist-tasks .ant-checkbox-wrapper .ant-checkbox-checked:after {\r\n  border-color: #01b81a;\r\n}\r\n\r\n.ninjadash-task-details .ant-modal-body .ninjadash-checklist-item .ninjadash-checklist-tasks-wrap button {\r\n  padding: 0px 35px;\r\n  color: #525768;\r\n  background-color: #f4f5f7;\r\n}\r\n\r\n.ninjadash-task-details .ant-modal-body {\r\n  max-height: 800px;\r\n  overflow-y: auto;\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  .ant-page-header {\r\n    padding: 26px 15px 26px 15px;\r\n  }\r\n}\r\n\r\n.page-header-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-wrap: wrap;\r\n  margin: -6px -4px;\r\n}\r\n\r\n.page-header-actions button {\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  height: 34px;\r\n  padding: 0 12.32px;\r\n  box-shadow: 0 3px 5px #9299b805;\r\n  margin: 6px 4px;\r\n}\r\n\r\n.page-header-actions button.ant-btn-white:focus {\r\n  background-color: #fff !important;\r\n}\r\n\r\n.page-header-actions button+button {\r\n  margin-left: 8px;\r\n}\r\n\r\n.page-header-actions button.ant-btn-white svg {\r\n  width: 12px;\r\n  height: 12px;\r\n  margin-right: 2px;\r\n  color: #8231D3;\r\n}\r\n\r\n/* Layout Css */\r\n\r\n.ant-menu-dark .ant-menu-item a {\r\n  font-weight: 400;\r\n  color: rgba(255, 255, 255, 0.65) !important;\r\n}\r\n\r\n.ant-menu-dark .ant-menu-item a:hover {\r\n  color: #ffffff;\r\n}\r\n\r\n.ant-menu-dark .ant-menu-submenu span {\r\n  color: rgba(255, 255, 255, 0.65) !important;\r\n}\r\n\r\n.ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected {\r\n  background-color: rgba(255, 255, 255, 0.05);\r\n}\r\n\r\n.ant-menu-inline-collapsed-tooltip a {\r\n  color: #000 !important;\r\n}\r\n\r\n.ant-menu.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow::before {\r\n  background: transparent;\r\n}\r\n\r\n/* Chart Label */\r\n\r\n.chart-label {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-bottom: 6px;\r\n  color: #404040;\r\n}\r\n\r\n.chart-label .label-dot {\r\n  margin-right: 8px;\r\n  width: 7px;\r\n  height: 7px;\r\n  border-radius: 50%;\r\n}\r\n\r\n.chart-label .label-dot.dot-success {\r\n  background: #01b81a;\r\n}\r\n\r\n.chart-label .label-dot.dot-info {\r\n  background: #8231D3;\r\n}\r\n\r\n.chart-label .label-dot.dot-warning {\r\n  background: #fa8b0c;\r\n}\r\n\r\n/* NOtification CSS */\r\n\r\n.ant-notification {\r\n  z-index: 99999 !important;\r\n}\r\n\r\n.rdrInputRange {\r\n  padding-left: 10px !important;\r\n}\r\n\r\n/* Overlay Dark */\r\n.overlay-dark {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: #10122130;\r\n  z-index: -1;\r\n  opacity: 0;\r\n  visibility: hidden;\r\n}\r\n\r\n.overlay-dark.show {\r\n  z-index: 998;\r\n  opacity: 1;\r\n  visibility: visible;\r\n}\r\n\r\n/* Responsive CSS */\r\n\r\n@media only screen and (max-width: 1599px) {\r\n  .ant-page-header.header-boxed {\r\n    padding: 26px 130px 26px 130px !important;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 1500px) {\r\n  .full-width-table .revenue-table {\r\n    min-height: 100%;\r\n  }\r\n\r\n  .pop-confirm .ant-btn {\r\n    padding: 0 20px;\r\n    max-width: 60px;\r\n  }\r\n\r\n  .pop-confirm.pop-confirm-right {\r\n    margin-left: 300px !important;\r\n  }\r\n\r\n  .pop-confirm.pop-confirm-bottom,\r\n  .pop-confirm.pop-confirm-top {\r\n    margin-left: 80px !important;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 1399px) {\r\n  .ant-page-header.header-boxed {\r\n    padding: 26px 50px 26px 50px !important;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 1199px) {\r\n  .ant-page-header {\r\n    padding: 0 15px;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 991px) {\r\n  .ant-page-header.header-boxed {\r\n    padding: 26px 30px 26px 30px !important;\r\n  }\r\n\r\n  .rdrMonths .rdrMonth {\r\n    width: 100%;\r\n    margin-bottom: 30px;\r\n  }\r\n\r\n  .rdrDateRangePickerWrapper.PreviewArea {\r\n    max-height: 300px;\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n  }\r\n\r\n  .rdrCalendarWrapper.rdrDateRangeWrapper {\r\n    margin-top: 20px;\r\n  }\r\n\r\n  .ant-menu-inline-collapsed-tooltip {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 800px) {\r\n  .ant-page-header-heading-left {\r\n    max-width: 320px;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 767px) {\r\n  .ant-page-header {\r\n    padding: 26px 15px 26px 15px;\r\n  }\r\n\r\n  .ant-page-header-heading {\r\n    flex-flow: column;\r\n    align-items: center;\r\n    justify-content: center !important;\r\n  }\r\n\r\n  .ant-page-header-heading-left {\r\n    max-width: 100%;\r\n  }\r\n\r\n  .ant-page-header-heading .ant-page-header-heading-title {\r\n    white-space: normal;\r\n    text-align: center;\r\n  }\r\n\r\n  .ant-page-header-heading-extra {\r\n    white-space: normal !important;\r\n    margin: 12px 0 4px !important;\r\n  }\r\n\r\n  .ant-page-header-heading-extra .page-header-actions {\r\n    white-space: normal !important;\r\n    text-align: center;\r\n  }\r\n\r\n  .ant-card-body {\r\n    padding: 20px !important;\r\n  }\r\n\r\n  .ant-card-head {\r\n    padding-left: 20px !important;\r\n    padding-right: 20px !important;\r\n  }\r\n\r\n  .ant-pagination .ant-pagination-item,\r\n  .ant-pagination .ant-pagination-item.ant-pagination-prev,\r\n  .ant-pagination .ant-pagination-item.ant-pagination-next,\r\n  .ant-pagination .ant-pagination-jump-prev {\r\n    margin-right: 5px;\r\n  }\r\n\r\n  .ant-pagination li.ant-pagination-item,\r\n  .ant-pagination li.ant-pagination-prev,\r\n  .ant-pagination li.ant-pagination-next,\r\n  .ant-pagination li.ant-pagination-jump-prev,\r\n  .ant-pagination li.ant-pagination-jump-next {\r\n    font-size: 13px;\r\n    height: 25px;\r\n    min-width: 25px;\r\n    line-height: 22px;\r\n  }\r\n\r\n  .ant-pagination li.ant-pagination-prev .anticon,\r\n  .ant-pagination li.ant-pagination-next .anticon {\r\n    vertical-align: 0.15em;\r\n  }\r\n\r\n  .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-ellipsis,\r\n  .ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-ellipsis {\r\n    line-height: 2;\r\n    font-family: \"Jost\", sans-serif;\r\n  }\r\n\r\n  .ant-table-pagination {\r\n    float: none !important;\r\n    text-align: center;\r\n  }\r\n\r\n  .ant-table-pagination li.ant-pagination-total-text {\r\n    display: block;\r\n    margin-bottom: 8px;\r\n  }\r\n\r\n  .ant-table-pagination li {\r\n    margin-right: 8px !important;\r\n  }\r\n\r\n  .ant-pagination .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {\r\n    height: 25px !important;\r\n  }\r\n\r\n  .ant-pagination .ant-select-single .ant-select-selector .ant-select-selection-item {\r\n    line-height: 23px !important;\r\n  }\r\n\r\n  .rdrDefinedRangesWrapper {\r\n    border-right: 0 none;\r\n  }\r\n\r\n  .project-modal .ant-picker {\r\n    margin-bottom: 30px;\r\n  }\r\n\r\n  .project-modal {\r\n    padding: 0 !important;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 575px) {\r\n  .mt-sm-10 {\r\n    margin-top: 10px;\r\n  }\r\n\r\n  .ant-page-header-heading-left {\r\n    margin-top: 0;\r\n  }\r\n\r\n  .btn-inc,\r\n  .btn-dec {\r\n    height: 30px;\r\n    width: 30px;\r\n  }\r\n\r\n  .ant-page-header {\r\n    padding: 26px 20px 16px;\r\n  }\r\n\r\n  .ant-layout-header {\r\n    height: auto;\r\n  }\r\n\r\n  .ant-card-head {\r\n    line-height: 1;\r\n  }\r\n\r\n  .ant-card-head-title {\r\n    white-space: normal !important;\r\n  }\r\n\r\n  .pop-confirm .ant-btn {\r\n    max-width: 60px;\r\n    padding: 0 20px;\r\n  }\r\n\r\n  .pop-confirm.pop-confirm-right {\r\n    margin-left: 320px !important;\r\n  }\r\n\r\n  .pop-confirm.pop-confirm-bottom {\r\n    margin-left: 95px !important;\r\n  }\r\n\r\n  /* Card Heading */\r\n  .ant-card-head-wrapper {\r\n    flex-flow: column;\r\n    align-items: center;\r\n  }\r\n\r\n  .ant-card-head-wrapper .ant-card-extra {\r\n    padding: 0 0 16px !important;\r\n    float: none;\r\n    margin: 0;\r\n    flex-flow: column;\r\n  }\r\n\r\n  .ant-card-head-wrapper .ant-card-extra .ant-dropdown-trigger+.card-nav {\r\n    margin-bottom: 8px;\r\n  }\r\n\r\n  .ant-card-head-wrapper .ant-card-extra .ant-dropdown-trigger {\r\n    margin: 0 !important;\r\n  }\r\n\r\n  .card-nav ul li.active:before {\r\n    display: none;\r\n  }\r\n\r\n  .ant-card-head-title>div {\r\n    display: flex;\r\n    flex-flow: column;\r\n    align-items: center;\r\n  }\r\n\r\n  .ant-card-head-title>div span {\r\n    margin: 8px 0 0;\r\n  }\r\n\r\n  .ant-picker-range-wrapper {\r\n    min-width: auto !important;\r\n  }\r\n\r\n  .ant-picker-panel-container .ant-picker-panels,\r\n  .ant-picker-datetime-panel {\r\n    flex-direction: column;\r\n  }\r\n}\r\n\r\n.bmzxig .ant-table tr th:first-child,\r\n.bmzxig .ant-table tr td:first-child {\r\n  padding-right: 15px;\r\n}\r\n\r\n/* Emprt */\r\n\r\n.ant-empty .ant-empty-footer button {\r\n  padding: 0px 15.58px !important;\r\n}\r\n\r\n/* Add Event Modal */\r\n.addEvent-modal .ant-modal-header {\r\n  padding: 20px 25px;\r\n}\r\n\r\n.addEvent-modal .ant-modal-header .ant-modal-close-x svg {\r\n  color: #404040;\r\n}\r\n\r\n.addEvent-modal .ant-modal-header .ant-modal-title {\r\n  font-size: 15px;\r\n  font-weight: 500;\r\n  color: #0A0A0A;\r\n}\r\n\r\n.addEvent-modal .ant-modal-body {\r\n  padding: 23px 25px;\r\n}\r\n\r\n/* Event Dropdown */\r\n\r\n.event-dropdown {\r\n  min-width: auto !important;\r\n  max-width: 450px;\r\n  padding: 0 !important;\r\n  margin: 6px 0 0 !important;\r\n  box-shadow: 0 10px 40px #9299b820 !important;\r\n}\r\n\r\n.event-dropdown div {\r\n  border-radius: 8px;\r\n}\r\n\r\n.event-dropdown .ant-card {\r\n  width: 100% !important;\r\n  margin-bottom: 0 !important;\r\n}\r\n\r\n.placement-confirm .ant-btn.ant-btn-white:hover {\r\n  border-color: #8231D3;\r\n}\r\n\r\n@media only screen and (max-width: 479px) {\r\n  .placement-confirm {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    margin: -5px -10px 0 -5px;\r\n  }\r\n\r\n  .placement-confirm .pop-confirm {\r\n    flex: 0 0 50%;\r\n  }\r\n\r\n  .pop-confirm .ant-btn {\r\n    display: block;\r\n    padding: 0 20px;\r\n    max-width: 80px;\r\n    min-width: 80px;\r\n    margin: 10px;\r\n  }\r\n\r\n  .pop-confirm.pop-confirm-right {\r\n    margin-left: 0px !important;\r\n  }\r\n\r\n  .pop-confirm.pop-confirm-top {\r\n    margin-left: 0px !important;\r\n  }\r\n\r\n  .pop-confirm.pop-confirm-bottom {\r\n    margin-left: 0px !important;\r\n    margin-top: 0px !important;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 400px) {\r\n  .ant-select {\r\n    width: 100% !important;\r\n  }\r\n\r\n  .rdrDefinedRangesWrapper {\r\n    width: 100% !important;\r\n  }\r\n\r\n  .rdrDateRangePickerWrapper {\r\n    flex-wrap: wrap;\r\n  }\r\n\r\n  .ninjadash-top-dropdown {\r\n    width: 280px;\r\n    min-width: 180px;\r\n  }\r\n\r\n  .ninjadash-top-dropdown .ninjadash-top-dropdown__title {\r\n    min-height: 40px;\r\n  }\r\n\r\n  .ninjadash-top-dropdown .ninjadash-top-dropdown__nav li:not(:last-child) {\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .ninjadash-top-dropdown .ninjadash-top-dropdown__nav li a {\r\n    padding: 10px 0px;\r\n  }\r\n\r\n  .ninjadash-top-dropdown .ninjadash-top-dropdown__content img {\r\n    margin-right: 15px;\r\n  }\r\n\r\n  .ninjadash-top-dropdown .ninjadash-top-dropdown__content figcaption {\r\n    margin-left: 0;\r\n  }\r\n\r\n  .ninjadash-top-dropdown .ninjadash-top-dropdown__content figcaption .ninjadash-top-dropdownText {\r\n    min-width: 155px;\r\n  }\r\n\r\n  .ant-drawer-content-wrapper {\r\n    width: 260px !important;\r\n  }\r\n\r\n  .rdrCalendarWrapper.rdrDateRangeWrapper {\r\n    margin-top: 0;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 379px) {\r\n  .ant-card-head-wrapper .ant-card-extra .ant-radio-button-wrapper {\r\n    height: 32px !important;\r\n    line-height: 30px !important;\r\n  }\r\n\r\n  .ant-notification-notice {\r\n    width: 275px;\r\n  }\r\n}\r\n\r\n@media (max-width: 575px) {\r\n  .ant-card-body {\r\n    padding: 15px !important;\r\n  }\r\n}\r\n\r\n@media (max-width: 991px) {\r\n  .mail-sideabr {\r\n    box-shadow: 0 0 10px #00000020;\r\n  }\r\n\r\n  .ant-card-head-title span {\r\n    margin-left: 10px;\r\n  }\r\n}\r\n\r\n/* Invoice Print Style */\r\n@media print {\r\n  .invoice-area .ant-page-header {\r\n    display: none;\r\n  }\r\n\r\n  .customizer-trigger {\r\n    display: none;\r\n  }\r\n}\r\n\r\n/* .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn{\r\n  color: #fff !important;\r\n} */\r\n\r\n/* custom label */\r\n\r\n/* card spin loader */\r\n\r\n.ant-card-body .sd-spin div,\r\n.ant-card-body .spin div {\r\n  position: relative;\r\n}\r\n\r\n.ant-card-body .sd-spin,\r\n.ant-card-body .spin {\r\n  height: 200px;\r\n}\r\n\r\n.ant-card-body {\r\n  position: relative;\r\n}\r\n\r\n.ant-card-body .sd-spin .ant-spin,\r\n.ant-card-body .spin .ant-spin {\r\n  display: flex;\r\n  align-items: center;\r\n  position: absolute;\r\n  left: 50%;\r\n  top: 50%;\r\n  transform: translate(-50%, -50%);\r\n  min-height: 200px;\r\n}\r\n\r\n.starActive svg {\r\n  color: red;\r\n}\r\n\r\n/* vectormap zoom in / zoom out */\r\n\r\n.jvectormap-zoomin,\r\n.jvectormap-zoomout {\r\n  width: 27px;\r\n  height: 27px;\r\n  background: none;\r\n  color: #404040;\r\n  border: 1px solid #f1f2f6;\r\n  padding: 0;\r\n  font-size: 15px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  left: auto;\r\n  right: 0;\r\n  top: auto;\r\n  background-color: #fff;\r\n}\r\n\r\n.jvectormap-zoomin {\r\n  border-radius: 6px 6px 0 0;\r\n  bottom: 36px;\r\n}\r\n\r\n.jvectormap-zoomout {\r\n  border-radius: 0 0 6px 6px;\r\n  bottom: 10px;\r\n}\r\n\r\n.jvectormap-tip {\r\n  padding: 7px 12px;\r\n  border: 0 none;\r\n  font-size: 12px;\r\n  background: #0A0A0A;\r\n}\r\n\r\n.btn-rtl {\r\n  width: 60px;\r\n  height: 60px;\r\n  border: 1px solid #fff;\r\n  background: #4347d9;\r\n  color: #fff;\r\n  position: fixed;\r\n  right: 0;\r\n  top: 50%;\r\n  margin-top: -30px;\r\n  z-index: 99999999;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n/* masonry-grid start from here */\r\n\r\n.my-masonry-grid {\r\n  display: -webkit-box;\r\n  /* Not needed if autoprefixing */\r\n  display: -ms-flexbox;\r\n  /* Not needed if autoprefixing */\r\n  display: flex;\r\n  margin-left: -10px;\r\n  /* gutter size offset */\r\n  width: auto;\r\n}\r\n\r\n.my-masonry-grid_column {\r\n  padding-left: 10px;\r\n  /* gutter size */\r\n  background-clip: padding-box;\r\n}\r\n\r\n/* Style your items */\r\n\r\n.my-masonry-grid_column>div {\r\n  /* change div to reference your elements you put in <Masonry> */\r\n  background: grey;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.common-ul {\r\n  padding: 5px 0;\r\n  padding-left: 10px;\r\n}\r\n\r\n.display {\r\n  display: none;\r\n}\r\n\r\nli.active>.display {\r\n  display: block;\r\n}\r\n\r\n/* rtl section from here */\r\nhtml[dir=\"rtl\"] .ant-card-head-title span {\r\n  margin-right: 15px;\r\n}\r\n\r\nhtml[dir=\"rtl\"] span[aria-label=\"arrow-right\"] svg,\r\nhtml[dir=\"rtl\"] span[aria-label=\"arrow-left\"] svg {\r\n  transform: rotateY(180deg);\r\n}\r\n\r\nhtml[dir=\"rtl\"] .ant-menu.ant-menu-vertical {\r\n  text-align: right !important;\r\n}\r\n\r\nhtml[dir=\"rtl\"] .ant-menu.ant-menu-vertical .ant-menu-submenu-placement-rightTop {\r\n  left: -170px !important;\r\n}\r\n\r\nhtml[dir=\"rtl\"] .ant-menu.ant-menu-vertical .ant-menu-vertical-left {\r\n  text-align: right;\r\n}\r\n\r\nhtml[dir=\"rtl\"] .ant-modal-confirm .ant-modal-confirm-btns .ant-btn+.ant-btn {\r\n  margin-left: 0;\r\n  margin-right: 8px;\r\n}\r\n\r\nhtml[dir=\"rtl\"] .ant-menu.ant-menu-vertical .ant-menu-submenu-arrow {\r\n  right: auto;\r\n  left: 16px;\r\n  transform: rotateY(180deg);\r\n}\r\n\r\nhtml[dir=\"rtl\"] .ant-menu-vertical .ant-menu-submenu-title {\r\n  padding-right: 15px !important;\r\n}\r\n\r\nhtml[dir=\"rtl\"] .project-modal-footer {\r\n  text-align: right !important;\r\n}\r\n\r\nhtml[dir=\"rtl\"] .ant-card-extra .ant-dropdown-trigger {\r\n  margin-right: 20px !important;\r\n  margin-left: 0 !important;\r\n}\r\n\r\nhtml[dir=\"rtl\"] .dark-mode .ninjadash-navbar-menu {\r\n  margin-right: 20px;\r\n}\r\n\r\n/* Dark Mode Css */\r\n.dark-mode .RichTextEditor__root___2QXK- .ButtonWrap__root___1EO_R button span {\r\n  display: flex;\r\n}\r\n\r\n.dark-mode .RichTextEditor__root___2QXK- .ButtonWrap__root___1EO_R button {\r\n  background: #a4a5aa;\r\n}\r\n\r\n.dark-mode .ninjadash-top-dropdown a.btn-seeAll,\r\n.dark-mode .ninjadash-top-dropdown .ninjadash-top-dropdown__nav li a:hover,\r\n.dark-mode .ant-picker-panel-container,\r\n.dark-mode .editor-compose .ant-input,\r\n.dark-mode .ant-drawer-content,\r\n.dark-mode .ant-dropdown,\r\n.dark-mode .mail-props,\r\n.dark-mode .ant-popover-inner,\r\n.dark-mode .ninjadash-searchbar .ant-input,\r\n.dark-mode .ant-input-group-addon,\r\n.dark-mode .ant-popover-arrow-content,\r\n.dark-mode .ant-drawer-header,\r\n.dark-mode .ant-popover-arrow-content:before {\r\n  background: #1b1e2b;\r\n}\r\n\r\n.dark-mode .ant-btn.ant-btn-white,\r\n.dark-mode .ant-notification-notice,\r\n.dark-mode .ant-pagination-prev .ant-pagination-item-link,\r\n.dark-mode .ant-pagination-next .ant-pagination-item-link,\r\n.dark-mode .ant-pagination .ant-pagination-prev,\r\n.dark-mode .ant-pagination .ant-pagination-next,\r\n.dark-mode .ant-pagination .ant-pagination-jump-prev,\r\n.dark-mode .ant-pagination .ant-pagination-jump-next,\r\n.dark-mode .ant-pagination .ant-pagination-item,\r\n.dark-mode .ant-pagination .ant-pagination-options .ant-select-selector,\r\n.dark-mode .ant-modal .ant-modal-header,\r\n.dark-mode .ant-modal .ant-modal-content,\r\n.dark-mode .ant-modal .ant-modal-content .ant-card,\r\n.dark-mode .ant-input,\r\n.dark-mode .ant-select:not(.ant-select-customize-input) .ant-select-selector,\r\n.dark-mode .ant-form-item-control-input .ant-picker,\r\n.dark-mode .ant-pagination-options-quick-jumper input {\r\n  background-color: #282b37;\r\n}\r\n\r\n.dark-mode .ninjadash-task-details .ninjadash-task-details-modal .ninjadash-task-details-modal__description textarea,\r\n.dark-mode .ant-picker-range-arrow::before,\r\n.dark-mode .ninjadash-top-dropdown .ninjadash-top-dropdown__title {\r\n  background-color: #323541;\r\n}\r\n\r\n.dark-mode .ant-picker-range-arrow {\r\n  background: linear-gradient(135deg, transparent 40%, #323541 40%);\r\n}\r\n\r\n.dark-mode .ant-btn.ant-btn-white,\r\n.dark-mode .ant-btn.ant-btn-dark,\r\n.dark-mode .ant-btn.ant-btn-dashed,\r\n.dark-mode .RichTextEditor__root___2QXK- .ButtonWrap__root___1EO_R button,\r\n.dark-mode .ant-popover-inner .ant-popover-inner-content a,\r\n.dark-mode .pop-confirm .ant-btn,\r\n.dark-mode .ant-pagination-disabled .ant-pagination-item-link,\r\n.dark-mode .ant-pagination-disabled:hover .ant-pagination-item-link,\r\n.dark-mode .ant-pagination .ant-pagination-item a,\r\n.dark-mode .ant-notification-notice-description,\r\n.dark-mode .ant-notification-notice-close-x svg,\r\n.dark-mode .ant-modal-close-x svg,\r\n.dark-mode .ant-drawer-body,\r\n.dark-mode .ant-modal-body,\r\n.dark-mode .ant-modal-confirm-body .ant-modal-confirm-content,\r\n.dark-mode .ant-form-item-control-input .ant-picker,\r\n.dark-mode .ant-select-arrow svg,\r\n.dark-mode .ant-picker-range-separator svg,\r\n.dark-mode .ant-picker-suffix svg,\r\n.dark-mode .ninjadash-searchbar .ant-input,\r\n.dark-mode .ant-picker-cell.ant-picker-cell-in-view,\r\n.dark-mode .ninjadash-task-details .ant-modal-header .ant-modal-title .sub-text,\r\n.dark-mode .ant-popover-message-title {\r\n  color: #a4a5aa;\r\n}\r\n\r\n.dark-mode .ant-picker-cell {\r\n  color: #a4a5aa25;\r\n}\r\n\r\n.dark-mode .ninjadash-top-dropdown__title,\r\n.ninjadash-task-details .ant-modal-body .ninjadash-checklist-row .ninjadash-checklist-item__title,\r\n.dark-mode .ninjadash-top-dropdown .ninjadash-top-dropdown__content figcaption h1,\r\n.dark-mode .ninjadash-top-dropdown .ninjadash-top-dropdown__nav li a:hover figcaption h1,\r\n.dark-mode .ninjadash-task-details .ant-modal-header .ant-modal-title h4,\r\n.dark-mode .ant-modal-title,\r\n.dark-mode .ant-modal-confirm-body .ant-modal-confirm-title,\r\n.dark-mode .ant-drawer-title,\r\n.dark-mode .ant-form-item-label>label,\r\n.dark-mode .ant-picker-header button,\r\n.dark-mode .ant-notification-notice-message {\r\n  color: #fff;\r\n}\r\n\r\n.dark-mode .ant-btn.ant-btn-white:hover {\r\n  color: #8231D3;\r\n}\r\n\r\n.dark-mode .ninjadash-task-details .ant-modal-body .ninjadash-checklist-tasks .ant-checkbox-wrapper .ant-checkbox-inner,\r\n.dark-mode .ant-btn.ant-btn-dark,\r\n.dark-mode .ant-btn.ant-btn-white.btn-outlined,\r\n.dark-mode .pop-confirm .ant-btn,\r\n.dark-mode .ant-pagination .ant-pagination-prev,\r\n.dark-mode .ant-pagination .ant-pagination-next,\r\n.dark-mode .ant-pagination .ant-pagination-jump-prev,\r\n.dark-mode .ant-pagination .ant-pagination-jump-next,\r\n.dark-mode .ant-pagination .ant-pagination-item,\r\n.dark-mode .ant-pagination-options-quick-jumper input,\r\n.dark-mode .ant-modal-header,\r\n.dark-mode .ant-modal-footer,\r\n.dark-mode .ant-pagination .ant-pagination-options .ant-select-selector,\r\n.dark-mode .ant-input-group-addon,\r\n.dark-mode .ant-select:not(.ant-select-customize-input) .ant-select-selector,\r\n.dark-mode .ant-form-item-control-input .ant-picker,\r\n.dark-mode .ant-picker-header,\r\n.dark-mode .ant-picker-panel-container .ant-picker-panel,\r\n.dark-mode .ant-drawer-header,\r\n.dark-mode .ant-input {\r\n  border-color: #323541 !important;\r\n}\r\n\r\n.dark-mode .ant-pagination .ant-pagination-prev,\r\n.dark-mode .ant-pagination .ant-pagination-next,\r\n.dark-mode .ant-pagination .ant-pagination-jump-prev,\r\n.dark-mode .ant-pagination .ant-pagination-jump-next,\r\n.dark-mode .ant-pagination .ant-pagination-item,\r\n.dark-mode .ant-pagination .ant-pagination-options .ant-select-selector {\r\n  border: 1px solid #282B37 !important;\r\n  background-color: #fff;\r\n}\r\n\r\n.dark-mode .ant-btn.ant-raised.ant-btn-white,\r\n.dark-mode .ant-badge-dot,\r\n.dark-mode .ant-badge-count {\r\n  box-shadow: 0 5px 10px #8c90a410;\r\n}\r\n\r\n.dark-mode .ant-btn.ant-btn-dashed {\r\n  border-color: #494b55;\r\n}\r\n\r\n.dark-mode .ninjadash-navbar-menu {\r\n  margin-left: 20px;\r\n}\r\n\r\n/* Top Menu */\r\n\r\n.ninjadash-topmenu .ninjadash-blog-details .ninjadash-share-links {\r\n  margin-left: 1000px !important;\r\n}\r\n\r\n/* Auth0 style */\r\n\r\n.auth0-lock.auth0-lock .auth0-lock-header-logo {\r\n  height: 32px !important;\r\n  margin: 0 0 3px !important;\r\n}\r\n\r\n.auth0-lock.auth0-lock .auth0-lock-name {\r\n  font-size: 16px !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
